export const provArea = {
  'Finnmark': 63650.93,
  'Nenets': 234616,
  'Norilsk': 115499.02,
  'Obdorsk': 131658.36,
  'Western Siberia': 389677.97,
  'Eastern Siberia': 416626.85,
  'Koryak': 247837.83,
  'Yarmanka': 157070.22,
  'Podzhiversk': 138681.54,
  'Nizhe-Kolymsk': 194259.65,
  'Anadyrsk': 225213.71,
  'Kagyrgyn': 440316.2,
  'Lappland': 200247.18,
  'Kola': 128530.79,
  'Archangelsk': 180685.12,
  'Hålogaland': 37330.09,
  'Mangazea': 140670.64,
  'Verkhoyansk': 153778.73,
  'West Greenland': 79620.46,
  'Greenland': 375149.06,
  'Baykha': 107485.04,
  'Komi': 143309.65,
  'Karelia': 95862.71,
  'Västerbotten': 68683.48,
  'Koda': 138237.77,
  'Berezov': 122684.28,
  'Österbotten': 50203.24,
  'Surgut': 162062.29,
  'Akureyri': 59815.02,
  'Reykjavik': 44521.05,
  'Seganka': 167811.58,
  'Uchamin': 173537.41,
  'Suntar Khayat': 137613.27,
  'Chuna': 131331.46,
  'Gizhiga': 174748.48,
  'Kharya': 169764.92,
  'Kamnuskoye': 121691.19,
  'Jämtland': 43424.08,
  'Savolax': 66331.8,
  'Trøndelag': 30748.75,
  'Kholmogory': 68002.95,
  'Narym': 153361.62,
  'North Urals': 108727.66,
  'Yakutsk': 200342.05,
  'Vestbygden': 40159.53,
  'Penchisky': 218761.63,
  'Tavastland': 33025.34,
  'Hälsingland': 25761.7,
  'Ust-Sysolsk': 175600.14,
  'Tauisk': 161732.57,
  'Olonets': 53155.54,
  'Alaska': 419101.74,
  'Yukon': 207510.89,
  'Northwest Territories': 942228.15,
  'Nunavut': 223442.57,
  'Baffin Island': 24424.29,
  'Sibir': 148125.14,
  'Sogn': 33539.55,
  'Eidsiva': 36605.56,
  'Yeniseysk': 153997.69,
  'Dalaskogen': 33855.15,
  'Ustyug': 136111.67,
  'Ilimsk': 205609.43,
  'Bratsk': 175799.99,
  'Agan': 132423.35,
  'Nunavik': 212156.91,
  'Kexholm': 17773.76,
  'Kargopol': 63654.36,
  'Finland': 31565.88,
  'Okhotsk': 201056.64,
  'Ostyaki': 106451.17,
  'Färöarnax': 1127.09,
  'Kenai': 56691.22,
  'Eiriksfjord': 17295.65,
  'Nukhtui': 194894.17,
  'Eyak': 54818.51,
  'Pegaya Orda': 90591.92,
  'Butalsk': 133338.5,
  'Akershus': 33805.53,
  'Nyland': 28535.23,
  'Värmland': 31598.38,
  'Bergslagen': 17677.88,
  'Viborg': 8101.63,
  'Bergenshus': 34823.45,
  'Tomsk': 171989.05,
  'Ungava': 149131.54,
  'Shetlands': 2280.15,
  'Uchurskoye': 78345.16,
  'Stockholm': 17101.34,
  'Solikamsk': 32524.65,
  'Vologda': 50313.2,
  'Neva': 6755.63,
  'Chulym': 119104.06,
  'Ladoga': 10895.76,
  'Tikhvin': 27982.14,
  'Sikumiut': 68041.04,
  'Kudymkar': 49266.49,
  'Yugan': 107841.73,
  'Viatka': 130706.31,
  'Yakutat': 14357.17,
  'Middle Urals': 130561.25,
  'Agder': 33293.37,
  'Kodiak': 68887.85999999999,
  'Chipewyan': 127033.86,
  'Sitka': 29092.98,
  'Närke': 12547.18,
  'Ingermanland': 14541.07,
  'Galich': 46144.15,
  'Jugjur': 193723.56,
  'Vah': 122956.12,
  'Estland': 13694.75,
  'Narva': 7064.54,
  'Östergötland': 14924.69,
  'Kachinsk': 138935.15,
  'Athabasca': 82186.2,
  'Novgorod': 33079.78,
  'Kostroma': 33629.03,
  'Ust-Kut': 126710.9,
  'Bohuslän': 4983.46,
  'Nihithawak': 89180.35,
  'Ösel': 3520.7400000000002,
  'Udmurtia': 61473.8,
  'Tyumen': 100561.9,
  'Verkne-Angarsky': 166730.27,
  'Verkohzehkoye': 199364.5,
  'North Quebec': 387098.38,
  'Västergötland': 20379.97,
  'Dorpat': 10535.45,
  'Pskov': 16324.91,
  'Torzhok': 22409.66,
  'Kamchatka': 248372.45,
  'Livland': 11005.66,
  'Columbia': 185807.74,
  'Highlands': 27534.01,
  'Tara': 170416.33,
  'Yaroslavl': 18582.63,
  'Perm': 52311.69,
  'Alberta': 97940.44,
  'Kan': 86246.86,
  'Sekani': 129111.98,
  'Rzhev': 24313.44,
  'Tver': 33047.3,
  'Småland': 29185.71,
  'Saskatchewan': 170786.67,
  'Gotland': 4137.34,
  'Wenden': 35798.75,
  'Kholm': 25593.75,
  'Chara': 217613.96,
  'Riga': 3238.64,
  'Aberdeen': 9434.26,
  'Kurland': 10469.2,
  'Tlingit': 29728.26,
  'Western Isles': 1294.27,
  'Ostrov': 20466.21,
  'Nordjylland': 8999.53,
  'Nijni-Novgorod': 31756.6,
  'Quennebigon': 105685.32,
  'Halland': 4618.62,
  'Swampy Cree': 65298.44,
  'Vladimir': 25091.72,
  'Kazan': 38283.45,
  'Kurgan': 58150.39,
  'Kulunda': 102739.7,
  'Semigallia': 9692.25,
  'Suzdal': 22686.66,
  'Omushkego': 75199.16,
  'Fife': 6525.74,
  'Veda-Suvar': 32560.08,
  'Saskatoon': 100017.87,
  'Smolensk': 62497.49,
  'Kuznetsk': 197202.61,
  "Nisga'a": 30401.84,
  'Cisapipi': 61345.73,
  'Memel': 6661.38,
  'Moskva': 23701.95,
  'Irkutsk': 241947.36,
  'Midtjylland': 12621.54,
  'Blekinge': 2953.54,
  'Polotsk': 22206.16,
  'Samogitia': 15793.73,
  'Kovno': 17178.54,
  'Skåne': 8972.71,
  'Orel': 18990.41,
  'Barnaul': 185028.69,
  'Ayrshire': 9645.1,
  'Sjælland': 5201.25,
  'Bashkortostan': 64943.48,
  'Lothian': 6882.26,
  'Kaluga': 22379.86,
  'Lithuania': 17021.46,
  'Lida': 18744.15,
  'Vitebsk': 17462.81,
  'Chelyaba': 42175.94,
  'Urkan': 149641.97,
  'Bashgird': 53310.93,
  'Northumberland': 8704.59,
  'Fyn': 2302.64,
  'Alatyr': 31050.65,
  'Ar-Chally': 27351.9,
  'Dakelh': 52309.21,
  'Nehiyawawin': 74546.28,
  'Naskapi': 148122.57,
  'Ribe': 4591.76,
  'Aksary': 84167.79,
  'Weagamow': 203717.4,
  'Ulster': 13140.87,
  'Ryazan': 23532.02,
  'Sayan': 51157.59,
  'Attawapiskat': 111927.31,
  'Connaught': 21318.69,
  'Bornholm': 453.01,
  'Kasimov': 18655.3,
  'Barguzinsky': 125946.23,
  'Cumbria': 6618.14,
  'Troki': 10456.91,
  'Simbirsk': 47978.55,
  'Woods Cree': 58576.74,
  'Lolland': 2383.53,
  'Ostpreussen': 6140.52,
  'Wystruc': 6125.98,
  'Slesvig': 4011.68,
  'Minsk': 32184.69,
  'Gdingen': 8316.73,
  'Hinterpommern': 9623.72,
  'Danzig': 2493.8,
  'Lower Ishim': 133750.76,
  'Holstein': 7741.87,
  'Samara': 23528.63,
  'Tsimshian': 29434.39,
  'Yorkshire': 11521.51,
  'Miyoo Gasan': 117502.58,
  'Tula': 19215.53,
  'Iglino': 71655.35,
  'Argyn': 110529.28,
  'Edmonton': 81230.52,
  'Vorpommern': 8592.3,
  'Marienburg': 8415.36,
  'Warmia': 10820.63,
  'Pensa': 36381.02,
  'Udskoye': 40867.85,
  'Atikaki': 75457.47,
  'Meath': 12715.48,
  'Podlasia': 20019.22,
  'Mogilyov': 27193.43,
  'Saghalian Oula': 158342.5,
  'Labrador': 48977.5,
  'Lübeck': 1462.78,
  'Mecklenburg': 11515.76,
  'Stettin': 6653.47,
  'Grodno': 14719.54,
  'Bryansk': 31543.86,
  'Buzuluk': 56703.16,
  'Kerey': 58108.07,
  'Haida': 8407.44,
  'Lancashire': 4537.59,
  'Tambow': 57090.38,
  'Shegendyk': 70507.19,
  'Neumark': 18649.96,
  'Wizna': 10796.23,
  'Bremen': 10310.04,
  'Lauenburg': 3828.41,
  'Birija': 144097.58,
  'Derby': 8269.94,
  'Sipiwininiwak': 67112.93,
  'Lincoln': 8536.84,
  'Brandenburg': 10241.27,
  'Torun': 11451.79,
  'Tannu Tuva': 183219.65,
  'East Frisia': 2318.99,
  'Oldenburg': 3683.06,
  'Poznan': 17673.19,
  'Plock': 10331.65,
  'Polesia': 21637.52,
  'Altai': 245119.74,
  'Friesland': 6116.54,
  'Ruppin': 6299.65,
  'Nerchinsky': 156807.46,
  'Albazinsky': 81998.53,
  'Rocky Mountains': 55991.02,
  'Secwepemc': 41726.13,
  'Leinster': 12154.5,
  'Lüneburg': 7817.66,
  'Kwakiutl': 52473.49,
  'Gwynedd': 11092.65,
  'Novgorod-Seversky': 25523.31,
  'Moose Cree': 48659.14,
  'Munster': 15929.43,
  'Marches': 11705.58,
  'Lipetsk': 20101.29,
  'Deren': 40226.32,
  'Mingan': 54330.2,
  'Turov': 34050.3,
  'Norfolk': 7755.74,
  'Oversticht': 4451.25,
  'Mazovia': 14342.86,
  'Kursk': 45558.68,
  'Etkara': 30806.48,
  'Agyidel': 71169.52,
  'Manicouagan': 83933.24,
  'Holland': 5537.01,
  'Osnabrück': 6556.94,
  'Altmark': 11386.3,
  'Brest': 17326.81,
  'Hannover': 19285.88,
  'Kalisz': 12213.67,
  'Mahmikiwiniyak': 51333.68,
  'Kanadey': 34159.01,
  'Udinsky': 109008.74,
  'Siksikawa': 71338.17,
  'Manitoba': 63715.29,
  'Oxfordshire': 9714.68,
  'Potsdam': 16997.49,
  'Leczyca': 10767.36,
  'Saratow': 23152.45,
  'Gelre': 4404.89,
  'Essex': 5879.1,
  'Münster': 6588.48,
  'Lippe': 10337.6,
  'Chernigov': 29870.04,
  'Québec': 115830.63,
  'Cree': 36971.51,
  'Glamorgan': 8911.21,
  'Utrecht': 2205.65,
  'Outoulibi': 54472.64,
  'Gloucestershire': 6106.45,
  'London': 5288.7,
  'Anhalt': 3929.11,
  'Meissen': 7724.38,
  'Lodz': 13436.86,
  'Galicien': 21059.55,
  'Voronezh': 36616.84,
  'Tsetserleg': 138644.75,
  'Yakesa': 244937.58,
  'Ktunaxa': 65814.33,
  'Innu': 31270.12,
  'Volhynia': 32819.05,
  'Calgary': 86010.05,
  'Noord': 3569.23,
  'Ukek': 35650.72,
  'Hebina': 67938.72,
  'Zeeland': 1251.9,
  'Berg': 8254.65,
  'Dresden': 17120.02,
  'Breslau': 14769.61,
  'Zhytomyr': 45307.18,
  'Limburg': 3633.28,
  'Lausitz': 10322.3,
  'Yaik': 29577.42,
  'Baganaly': 68478.89,
  'Kassel': 6214.56,
  'Leipzig': 7533.25,
  'Sandomir': 19823.25,
  'Heiltsuk': 29295.73,
  'Winnipeg': 45465.89,
  'Taqamkuk': 40078.37,
  'Tortkara': 61443.62,
  'Kypshak': 101481.75,
  'Brabant': 6306.75,
  'Kiev': 25640.89,
  'Utva': 53923.12,
  'Cornwall': 14189.24,
  'Wessex': 8138.34,
  'Kent': 2645.53,
  'Köln': 3188.92,
  'Pereyaslav': 24616.35,
  'Borisoglebsk': 37658.73,
  'Okanagan': 41727.91,
  'Antwerpen': 2575.88,
  'Hessen': 6672.32,
  'Vlaanderen': 3615.06,
  'Erfurt': 10263.47,
  'Poltava': 40227.88,
  'Wappus': 57525.16,
  'Calais': 1468.9,
  'Nassau': 4799.52,
  'Ratibor': 11363.8,
  'Jetyru': 56623.69,
  'Tsaritsyn': 56047.82,
  'Aigun': 44816.64,
  'Ghent': 2279.48,
  'Erz': 8076.34,
  'Urzhar': 193939.88,
  'Ih Huree': 166674.66,
  'Kuru': 74539.22,
  'Regina': 68942.72,
  'Shaggami': 49490.42,
  'Artois': 7004.2,
  'Liège': 4295.45,
  'Aachen': 2548.43,
  'Bohemia': 25372.49,
  'Belz': 6774.52,
  'Mergen': 37393.35,
  'Nootka': 29685.32,
  'Namur ': 4207.29,
  'Koblenz': 5167.07,
  'Würzburg': 8092.26,
  'Krakow': 28804.36,
  'Govi Altay': 187700.55,
  'Kesagami': 39958.24,
  'Piekougami': 66381.39,
  'Hainault': 4351.82,
  'Wusuli': 117893.86,
  'Picardie': 6380.48,
  'Cambray': 4864.41,
  'Bamberg': 7514.36,
  'Lower Yaik': 43281.17,
  'Tobykty': 136550.05,
  'Przemysl': 11245.94,
  'Plsen': 22050.47,
  'Moravia': 24064.28,
  'Kharkov': 24202.56,
  'Orda': 41674.05,
  'Squamish': 18173.03,
  'Ojibwa': 50119.88,
  'Frankfurt': 1757.52,
  'Arlon': 3041.28,
  'Trier': 6415.69,
  'Pfalz': 7638.28,
  'Dornod': 210158.53,
  'Abitbi': 54655.22,
  'Luxemburg': 2501.86,
  'Oberpfalz': 3927.55,
  'Sarai': 57686.99,
  'Bayuly': 64639.76,
  'Shekty': 55162.87,
  'Khangai': 95610.54,
  'Beothuk': 36736.61,
  'Valenciennes': 6133.01,
  'Ruthenia': 42838.6,
  'Podolia': 21311.46,
  'Caux': 9190.33,
  'Alzey': 8430.99,
  'Bahmut': 17476.55,
  'Sakhalin': 36676.39,
  'Vermandois': 5483.18,
  'Bratslav': 32638.35,
  'Cherkasy': 30174.68,
  'Nipigon': 44654.8,
  'Leiningen': 9073.78,
  'Île-de-France': 17471.66,
  'Worms': 4281.71,
  'Franken': 3426.46,
  'Cherkassk': 48664.28,
  'Nadym': 96125.16,
  'Selenge': 101021.71,
  'Normandie': 14436.02,
  'Barrois': 11645.08,
  'Atiamekw': 15183.63,
  'Champagne': 19313.57,
  'Ersekujvar': 19777.32,
  'Metz': 5805.81,
  'Altyn': 85388.42,
  'Bungi': 43358.39,
  'Niederbayern': 17291.11,
  'Carpathia': 16489.5,
  'Kespek': 22889.49,
  'Baden': 3402.93,
  'Mansur': 27557.62,
  'Dzhaman-Kuduk': 114287.51,
  'Elsass': 7745.51,
  'Alimuly': 95921.96,
  'Hoboksar': 129537.78,
  'Württemberg': 7837.37,
  'Hunyad': 51663.1,
  'Salish': 20086.97,
  'Yakima': 53696.56,
  'Spokane': 40527.06,
  'Piegan': 98976.6,
  'Haaninin': 56309.26,
  'Hidatsa': 53522.76,
  'Itscheabine': 62361.33,
  'Atikamekw': 51789.7,
  'Ulm': 2824.24,
  'Ostmarch': 8490.39,
  'Presburg': 14268.12,
  'Maliseet': 8933.66,
  'Placentia': 35336.26,
  'Armor': 13581.19,
  'Alencon': 11321.47,
  'Lothringen': 7630.43,
  'Schwaben': 10212.49,
  'Tyn': 16344.05,
  'Piscatang': 45372.01,
  'Linz': 9930.08,
  'Zaporozhia': 22147.61,
  'Chippewa': 40551.92,
  'Nevers': 10429.24,
  'Bukovina': 7667.01,
  'Alty-Kuduk': 39321.13,
  'München': 13677.74,
  'Szabolcs': 17936.33,
  'Bessarabia': 32021.22,
  'Zasagt': 171875.22,
  'Maine': 9560.91,
  'Nemours': 9527.17,
  'Breisgau': 6776.07,
  'Konstanz': 5555.17,
  'Augsburg': 3905.37,
  'Wien': 11679.66,
  'Ryn': 48210.21,
  'Nogay': 63113.53,
  'Heilongjiang': 72697.68,
  'Quileute': 12094.17,
  'Kyzyl-Yar': 29002.33,
  'Cicigar': 30289.62,
  'Morbihan': 8420.44,
  'Suceava': 43200.42,
  'Ingil': 26010.94,
  'Sanxing': 106443.31,
  'Timiskaming': 22948.2,
  'Siknikt': 11706.88,
  'Orléannais': 10392.6,
  'Bourgogne': 15821.08,
  'Sundgau': 4096.47,
  'Salzburg': 7030.47,
  'Pecs': 14767.81,
  'Yedisan': 29041.41,
  'Ashshipite': 56254.51,
  'Sault': 37698.8,
  'Kwedech': 32690.08,
  'Madawaska': 22427.78,
  'Franche-Comté': 16967.68,
  'Khazaria': 38738.29,
  'Palus': 47344.35,
  'Steiermark': 11713.24,
  'Sopron': 13214.44,
  'Partium': 17049.49,
  'Qaraqorum': 114856.23,
  'Mandan': 46074.34,
  'Anjou': 11896.49,
  'Szolnok': 27008.55,
  'Vendée': 5423.59,
  'Berry': 16854.54,
  'Azow': 11526.64,
  'Mdewankton': 31583.42,
  'Zürich': 5820.66,
  'Graz': 10697.06,
  'Astrakhan': 45689.22,
  'Minnesota': 53532.26,
  'Tirol': 11812.9,
  'Chehalis': 22869.72,
  'Ottawa': 33274.68,
  'Aroostook': 25819.9,
  'Bourbon': 9646.35,
  'Bern': 9977.79,
  'S:t Gallen': 4461.16,
  'Somogy': 17974.86,
  'Transylvania': 21042.88,
  'Iman': 72369.29,
  'Apsaalooke': 100850.29,
  'Menominee': 37903.62,
  'Yedishkul': 24215.52,
  'Azaraba': 25189.22,
  'Lakota East': 62007.39,
  'Lienz': 6687.34,
  'Sartu': 34606.36,
  'Lakota West': 47372.72,
  'Etchemins': 16738.93,
  'Micmac': 15732.38,
  'Kärnten': 9045.52,
  'Charolais': 10095.17,
  'Chuguchak': 53466.39,
  'Washington': 46433.79,
  'Epekwitk': 6041.67,
  'Unamakik': 7280.95,
  'Chur': 5932.96,
  'Kuma': 33554.28,
  'Yaran': 41020.7,
  'Algonquin': 24546.13,
  'Poitou': 24151.67,
  'Niklas': 17642.1,
  'Schwyz': 6064.56,
  'Trent': 12720.44,
  'Chahar': 225954.62,
  'Noquet': 47111.55,
  'Hochelega': 21110.61,
  'Krain': 10333.55,
  'Kouban': 26788.17,
  'Turkestan': 104978.98,
  'Dorno Govi': 237743.68,
  'Eeelalapito': 65457.76,
  'Friuli': 8440.35,
  'Xilin Gol': 89259.87,
  'Lyonnais': 7683.38,
  'Treviso': 4962.54,
  'Slavonia': 8488.96,
  'Syghnak': 76442.48,
  'Karamegdan': 62459.56,
  'Wolystooq': 22190.89,
  'Savoie': 13469.86,
  'Lombardia': 11425.17,
  'Görz': 9494.75,
  'Banat': 25475.59,
  'Budjak': 12318.09,
  'Chinook': 19052.68,
  'Missisage': 13318.6,
  'Loup': 14544.7,
  'Limousin': 18127.77,
  'Brescia': 8407.15,
  'Arsigantegok': 12617.01,
  'Abnaki': 14504.32,
  'Auvergne': 25841,
  'Majar': 24846.95,
  'Umatilla': 59045.27,
  'Sauk': 29996.15,
  'Torontal': 18045.19,
  'Tsisistas': 50626.71,
  'Acadia': 11162.15,
  'Crimea': 12444.72,
  'Alchuka': 38471.53,
  'Arikara': 48848.33,
  'Kennebec': 18493.67,
  'Verona': 6054.74,
  'Croatia': 9033.8,
  'Zhetysu': 124168.16,
  'Hinggan': 41212.06,
  'Eskikewakik': 12186,
  'Osijek': 12997.96,
  'Mangyshlak': 65540.8,
  'Urumqi': 101602.06,
  'Govi': 171877.39,
  'Passamaquoddy': 11928.09,
  'Venezia': 5060.97,
  'Ninguta': 38468.11,
  'Bogohue': 71703.4,
  'Michigan': 26412.83,
  'Kichesipi': 16533.12,
  'Dauphiné': 14988.97,
  'Wallachia': 44804.47,
  'Mantrega': 6049.67,
  'Circassia': 32463.51,
  'Kabardia': 35587.49,
  'Ust Yurt': 64584.97,
  'Okouara': 31844.16,
  'Périgord': 13032.97,
  'Mantua': 7952.91,
  'Lika': 10472.87,
  'Oltenia': 31560.03,
  'Kungirot': 75341.93,
  'Taraz': 105399.20,
  'Huron': 17746.31,
  'Dobruja': 12289.24,
  'Kamikawa': 25428.41,
  'Kalapuya': 50209.90,
  'Wahpekute': 47349.67,
  'Winnebago': 33412.98,
  'Sokoki': 11470.93,
  'Gascogne': 13059.42,
  'Kaffa': 11746.34,
  'Odawa': 9255.34,
  'Languedoc': 16242.76,
  'Ferrara': 5084.25,
  'Theodoro': 5278.39,
  'Dzungaria': 89050.3,
  'Mudanjiang': 35202.57,
  'Kurils': 2007.89,
  'Adirondack': 20998.57,
  'Missisquoi': 13250.91,
  'Modena': 8428.4,
  'Soli': 15930.42,
  'Bosnia': 15392.55,
  'Kuruk Tag': 109724.79,
  'Ereen': 78735.27,
  'Idaho': 68530.53,
  'Parma': 6000.82,
  'Serbia': 25510.41,
  'Terek': 28925.66,
  'Hami': 152210.18,
  'Ontario': 17746.41,
  'Kespukwitk': 13256.54,
  'Turin': 7818.44,
  'Liguria': 8997.5,
  'Ubykhia': 16993.85,
  'Rouergue': 9988.6,
  'Fox': 37886.66,
  'Tkaronto': 12530.41,
  'Romagna': 7137.55,
  'Sozak': 57972.28,
  'Haixi': 41422.94,
  'Oglala': 55356.51,
  'Androscoggin': 11930.57,
  'Provence': 19668.17,
  'Nice': 3110.82,
  'Dakota': 96703.5,
  'Tionontate': 9939.75,
  'Avignon': 3779.83,
  'Oregon': 98067.04,
  'Great Plains': 43184.56,
  'Wyoming': 88051.03,
  'Oneida': 15253.29,
  'Mohawk': 18176.8,
  'Toulouse': 16336.54,
  'Tarki': 13065.06,
  'Labourd': 7481.89,
  'Armagnac': 7576.73,
  'Firenze': 10240.15,
  'Dalmatia': 9131.67,
  'Raska': 15371.52,
  'Tokachi': 35024.25,
  'Ancona': 9913.69,
  'Hum': 12252.21,
  'Vidin': 13333.63,
  'Silistria': 16791.58,
  'Nakota': 32003.93,
  'Pocumtuk': 9667.28,
  'Nis': 36455.64,
  'Yehe': 19908.86,
  'Narbonne': 9954.19,
  'Qaraqalpak': 34567.6,
  'Connecticut': 24359.26,
  'Merrimack': 5870.73,
  'Pisa': 2866.99,
  'Hunchun': 30742.95,
  'Galicia': 27908.6,
  'Bulgaria': 24501.14,
  'Alania': 16851.29,
  'Kyrzyl-Kum': 59732.76,
  'Ulaanchab': 99166.59,
  'Klamath': 34005.13,
  'Asturias': 8988.4,
  'Béarn': 13129.82,
  'Liaodong': 64068.48,
  'Mascouten': 20033.07,
  'Onondaga': 12297.52,
  'Mahican': 10879.95,
  'Cantabria': 6002.98,
  'Vizcaya': 7028.41,
  'Travunia': 4674.15,
  'Zeta': 14721.14,
  'Abkhazia': 8805.01,
  'Khundzia': 23406.15,
  'Niagara': 19106.42,
  'Allegheny': 41514.55,
  'Ragusa': 3775.5,
  'Cayuga': 11520.17,
  'Navarra': 10888.96,
  'Siena': 6645.08,
  'Roma': 17572.41,
  'Hetu Ala': 40499.65,
  'Shiribeshi': 17207.83,
  'Burgos': 15683.8,
  'Kosovo': 9844.35,
  'Georgia': 17653.46,
  'Potawatomi': 16106.86,
  'León': 30714.89,
  'Burgas': 11296.33,
  'Urgench': 38998.54,
  'Roussillon': 4839.75,
  'Imereti': 15194.54,
  'Dagestan': 13026.63,
  'Shymkent': 41714.78,
  'Tiam Shan': 127487.45,
  'Yukjin': 10339.37,
  'Goshute': 69919.59,
  'Pirineo': 14140.54,
  'Corsica': 5839.66,
  'Abbruzzi': 15652.87,
  'Naryn': 89461.82,
  'Baachinena': 74764.76,
  'Moingwena': 43547.32,
  'Massachusetts': 4064.88,
  'Girona': 19348.54,
  'Talas': 35601.78,
  'Ejin': 94344.92,
  'Soria': 18293.02,
  'Kartli': 20033.93,
  'Gurganj': 17016.59,
  'Skiri': 52028.56,
  'Iowa': 52181.86,
  'Illinois': 36509.29,
  'Albania': 28538.3,
  'Plovdiv': 23161.39,
  'Kakheti': 7590.08,
  'Espachomy': 9832.22,
  'Yumen': 103386.2,
  'Great Salt Lake': 115837.82,
  'Atrakwaye': 25677.77,
  'Wampanoag': 4194.97,
  'Porto': 6423.41,
  'Kara Kum': 120292.97,
  'Tashkent': 25552.12,
  'Chengde': 39513.07,
  'Liaoxi': 28516.75,
  'Great Basin': 138881.17,
  'Macedonia': 21950.07,
  'Ningxia': 179336.32,
  'Pawnee': 35091.77,
  'Wea': 24304.13,
  'Wyandot': 27597.9,
  'Munsee': 13484.43,
  'Quinnipiac': 5770.18,
  'Narraganset': 5923.07,
  'Aragón': 30220.62,
  'Andong': 27903.27,
  'Yuki': 33285.68,
  'Shasta': 27621.83,
  'Miami': 27808.95,
  'Erie': 25915.68,
  'Bragança': 11667.15,
  'Edirne': 16008.79,
  'Sinope': 15449.77,
  'Atakent': 44559.45,
  'North Hamgyeong': 27816.8,
  'Manhattan': 11043.13,
  'Bari': 12096.8,
  'Thrace': 8268.66,
  'Kastamon': 20977.88,
  'Khiva': 42433.7,
  'Castilla La Vieja': 17385.19,
  'Barcelona': 12135.95,
  'Komotini': 10060.1,
  'Qarabagh': 28982.33,
  'Murgan': 45510.13,
  'Hohhot': 38277.08,
  'Xuan Fu': 33258.34,
  'Cahokia': 29574.4,
  'Napoli': 16896.41,
  'Bolu': 15347.77,
  'North Pyongan': 26591.94,
  'Guria': 8851.29,
  'Kuqa': 50883.18,
  'Korla': 73061.66,
  'Salonica': 17867.65,
  'Canik': 17395.59,
  'Bukhara': 41958.35,
  'Kokand': 18823.94,
  'Salamanca': 14803.81,
  'Mutsu': 46681.76,
  'Hinonoeino': 98664.87,
  'Raritan': 9195.94,
  'Madrid': 22207.68,
  'Trebizon': 17446.5,
  'Samtskhe': 12312.87,
  'Armenia': 25318.06,
  'Ordos': 112039.01,
  'Kilatika': 28894.27,
  'Lenape': 10665.2,
  'Ribatejo': 10454.06,
  'Beira': 12496.97,
  'Cuenca': 25074.88,
  'Sardinia': 20701.77,
  'Lucania': 9932.93,
  'Kozani': 14889.89,
  'Bithynia': 9614.93,
  'Uighuristan': 59339.33,
  'Apulia': 6650.77,
  'Qakilik': 91887.41,
  'Datong': 33784.43,
  'Colorado': 97393.48,
  'Missouri': 91450.81,
  'Kaskaskia': 30245.09,
  'Ohio': 32031.02,
  'Honniasont': 17942.6,
  'Susquehanna': 11451.93,
  'Kizil-Su': 58545.43,
  'Khujand': 22864.39,
  'Hejian': 53281,
  'Gaizhou': 21445.01,
  'Juniata': 14617.53,
  'Yozgat': 20635.47,
  'Erserum': 40804.9,
  'Uzkend': 42481.81,
  'Utah': 154854.99,
  'Bozok': 17966.5,
  'Samarkand': 25907.84,
  'Hamgyeong': 21915.23,
  'València': 14843.89,
  'Biga': 12343.02,
  'Bursa': 25609.94,
  'Angora': 32005.06,
  'Tamaroa': 33591.36,
  'Chillicothe': 29092.55,
  'Kashgar': 51050.44,
  'Gansu': 57974.21,
  'Dewa': 17459.27,
  'Wabash': 29142.11,
  'Melikates': 18347.41,
  'Uiji': 16660.97,
  'Caceres': 19784.46,
  'Larissa': 12277.58,
  'Sivas': 38654.46,
  'Unami': 6788.64,
  'Calabria': 13650.99,
  'Monongahela': 16994.9,
  'Lisboa': 10709.35,
  'Toledo': 12675.39,
  'Janina': 19875.96,
  'Kitkehaki': 45656.03,
  'Piankeshaw': 23922.04,
  'Nanticoke': 16785.3,
  'Anatolia': 24241.54,
  'Van': 29056.85,
  'Charjuy': 78921.46,
  'Yarkand': 91429.99,
  'Maidu': 37176.12,
  'Delaware': 3761.56,
  'Takla Makan': 154451.78,
  'Potomac': 11728.77,
  'Nakhchivan': 4521.69,
  'Handan': 55183.09,
  'Urmia': 27067.65,
  'Shirva': 16654.09,
  'Qarshi': 48846.15,
  'Sanguan': 39740.45,
  'Dalian': 3562.56,
  'Pomo': 13222.16,
  'Alentejo': 31761.2,
  'Erzincan': 22902.76,
  'Kulob': 49456.9,
  'Guyuan': 26332.55,
  'Manahoac': 44841.29,
  'La Mancha': 40795.84,
  'Atak': 39046.91,
  'Badakhshan': 72627.57,
  'Conoy': 5265.56,
  'Badajoz': 20206.99,
  'Lesbos': 2772.85,
  'Smyrna': 10853.96,
  'Kayseri': 29226.41,
  'Malatya': 21713.7,
  'Mush': 32033.83,
  'Sarig Yogir': 173474.71,
  'Nevada': 153650.09,
  'Kanawha': 26157.94,
  'Alicante': 10702.45,
  'Saruhan': 24256.4,
  'Azerbaijan': 35085.56,
  'Beijing': 22610.57,
  'Doeg': 10403.17,
  'Athens': 14585.8,
  'Konya': 27995.59,
  'Konjikala': 47578.38,
  'Liangzhou': 42879.95,
  'Pyeongan': 18335.55,
  'Shatteras': 34721.1,
  'Murcia': 17277.1,
  'Mus': 35173.52,
  'Michigamea': 44277.74,
  'Mengkonkia': 23174.51,
  'Hamid': 24335.19,
  'Kiowa': 54141.5,
  'Utsetha': 52915.54,
  'Córdoba': 14156.07,
  'Karakoram': 42073.42,
  'Miwok': 22567.08,
  'Dakhshan': 38505.76,
  'Kentucky': 37257.14,
  'Qarqan': 53385.92,
  'Kulun Shan': 366975.17,
  'Taiyuan': 25061.88,
  'Gangwon': 7669.68,
  'Osage': 55345.04,
  'Marv': 72043.14,
  'West Gangwon': 15957.88,
  'Echigo': 6525.64,
  'Jicarilla West': 61699.27,
  'Achaea': 14537.28,
  'Karaman': 21477.56,
  'Wuding': 15706.82,
  'Palermo': 9199.38,
  'Diyarbakir': 35237.27,
  'Cizre': 24653.4,
  'Gurgan': 21446.66,
  'Bojnord': 43336.22,
  "Yan'an": 61037.22,
  'Moratok': 20836.73,
  'Andalucía': 22384.8,
  'Messina': 14164.54,
  'Gilan': 18139.32,
  'Amdo': 267889.22,
  'Xining': 47553.34,
  'Gyeonggi': 8750.8,
  'Comanche': 146675.8,
  'Almería': 9850.82,
  'Antalya': 30171.92,
  'Yorkuts': 33819.71,
  'Cumberland': 27895.97,
  'Adana': 21937.69,
  'Shandong Bandao': 27317.41,
  'Navajo': 48928.01,
  'Monacan': 14217.49,
  'Zanjan': 23548.77,
  'Kunduz': 35381.38,
  "Lu'an": 41880.8,
  'Canyon': 52937.76,
  'Granada': 21130.91,
  'Morea': 8709.2,
  'Tekke': 18475.22,
  'Khurasan': 82537.55,
  'Lanzhou': 50350.7,
  'Jinan': 29197.51,
  'Algarve': 5051.62,
  'Maragheh': 38107.79,
  'Maymana': 47025.92,
  'Balkh': 40877.19,
  'Pingliang': 67438.8,
  'Tutelo': 15943.85,
  'Hotan': 48238.65,
  'Powhatan': 7729.74,
  'Mosul': 36698.31,
  'Daming': 31842.46,
  'Etchu': 29706.51,
  'Pennyrile': 13593.8,
  'Cadiz': 7991.29,
  'Bizerte': 10861.11,
  'Icel': 17396.07,
  'Qingzhou': 32926.57,
  'Shinano': 17021.35,
  'Kozuke': 15523.24,
  'Hitachi': 13142.16,
  'Pueblo': 25914.57,
  'Dayr Az Zor': 57858.52,
  'Kashmir': 104496.75,
  'Salinan': 15446.89,
  'Jicarilla East': 53916.79,
  'Bône': 12602.75,
  'Tunis': 12490.98,
  'Antioch': 7857.01,
  'Changzhi': 34386.81,
  'Chungcheong': 22277.19,
  'Gyeongsang': 10805.06,
  'Wichita': 94089.48,
  'Kabylia': 21537.66,
  'Sinjar': 30266.66,
  'Qumis': 42084.14,
  'Hualapai': 50409.66,
  'Cherokee': 46828.6,
  'Al-Djazair': 12837.21,
  'Constantine': 28168.62,
  'Aleppo': 21514.27,
  'Mazandaran': 39586.7,
  'Huaiqing': 12720.97,
  'Yanzhou': 45621.76,
  'Qingdao': 3663.74,
  'Shawnee': 26209.35,
  'Cheraw': 27435.04,
  'Yadkin': 21133.28,
  'Roanoke': 16608.59,
  'Gibraltar': 2492.29,
  'West Gyeongsang': 17532.2,
  'Quapaw': 47238.23,
  'Dahra': 10781.41,
  'Qazvin': 25577.6,
  'Sabzevar': 42659.98,
  'Jalalabad': 34820.88,
  'Tachi': 39906.38,
  'Acoma': 38182.97,
  'Satuskhdin': 35849.51,
  'Tuscarora': 19845.16,
  'Kef': 21796.62,
  'Musachi': 11208.05,
  'Echizen': 2634.54,
  'Tennessee': 23954.65,
  'Ardalan': 26453.95,
  'Titteri': 28978.53,
  'Sharizhor': 33933.85,
  'Hopi': 28814.97,
  'Zuni': 25635.76,
  'Fez': 39724.73,
  'Ouarsenis': 44643.97,
  'Hodna': 22046.75,
  'Latakia': 11418.49,
  'Tangiers': 6582.98,
  'Oran': 7721.95,
  'Souss': 10540.35,
  'Ajam': 27852.11,
  'Semnan': 37205.05,
  'Mojave': 55450.89,
  'Chickamauga': 23337.84,
  'Waxhaw': 15244.21,
  'Pamlico': 11502.08,
  'Tajima': 7676.23,
  'Kyoto': 6515.42,
  'Crete': 8113.07,
  'Rahba': 21751.36,
  'Kabulistan': 38147.23,
  'Jeolla': 12956.8,
  'Cyprus': 7985.22,
  'Gharchistan': 56219.81,
  'Izumo': 3803.16,
  'Mellila': 3285.4,
  'Hamah ': 23276.44,
  'Herat': 62195.23,
  'Ladakh': 58255.95,
  'Shaanxi': 42587.99,
  'Nagato': 13219.02,
  'Owari': 6639.4,
  'Chumash': 26821.67,
  'Tlemcen': 14791.2,
  'Biskra': 36543.87,
  'Khyber': 54431.15,
  'Taozhou': 53451.41,
  'Tianshui': 38496.27,
  'Harima': 9787.69,
  'Settsu': 4280.79,
  'Napochi': 30916.85,
  'Saluda': 26739.94,
  'Catawba': 17957.99,
  'Chicora': 16528.32,
  'Oujda': 19734.64,
  'Tikrit': 25475.09,
  'Hamadan': 36483.38,
  'Aki': 7116.04,
  'Apache': 46840.05,
  'Mescalero': 65968.13,
  'Caddo': 42652.41,
  'Kirmanshah': 43412.79,
  'Dangla': 172703.01,
  'Luoyang': 30518.11,
  'Kaifeng': 19728.96,
  'Xuzhou': 18885.65,
  "Huai'an": 24925.97,
  'Yazoo': 22348.93,
  'Chickasaw': 24658.24,
  'Sfax': 16137.58,
  'Markazi': 43786.63,
  'Margalla': 29872.01,
  'Waccamaw': 11749.13,
  'Gharb': 17453.98,
  'Tadmor': 28505.59,
  'As Sahiliyah': 29451.59,
  'Jammu': 49779.36,
  'Yavapai': 50098.97,
  'Piro': 38822.94,
  'Arkansas': 23385.6,
  'Aures': 63017.61,
  'Gafsa': 53675.05,
  'U-Tsang': 317692.64,
  'Shangqiu': 21883.58,
  'Yamato': 8345.92,
  'Coweta': 17925,
  'Kasdir': 63152.95,
  'Bamyan': 61359.77,
  'Waco': 58257.37,
  'Beirut': 4933.93,
  'Dege': 51807.45,
  'Awa': 4035.86,
  'Tuskegee': 30111.51,
  'Yamasee': 54194.03,
  'Ardakan': 46444.02,
  'Guge': 55169.04,
  'Birjand': 88410.74,
  'Gazni': 58156.72,
  'Fengyuan': 57824.55,
  'Fengyang': 32544.34,
  'Kumeyaay': 28936.09,
  'Chiricahua': 43100.97,
  'Lipiyanes': 61126.47,
  'Tohome': 28788.69,
  'Meknes': 19750.99,
  'Damascus': 26739.64,
  'Badiyat Ash Sham': 106954.17,
  'Iraq-i-Arab': 24363.44,
  'Fuyang': 18983.24,
  'Tosa': 12024.4,
  'Hasinai': 44628.72,
  'Santee': 12360.75,
  'Qamdo': 70711.46,
  'Songqu': 42804.76,
  'Chikuzen': 10575.22,
  'Toubkhal': 11283.37,
  'Sidon': 4058.97,
  'Sind Sagar': 36601.78,
  'Kham': 53957.73,
  'Xiangxang': 55082.98,
  'Atlas': 31481.41,
  'Touggourt': 53691.85,
  'Gabes': 20217.07,
  'Fars': 40901.28,
  'Nanyang': 25132.3,
  'Bungo': 12718.25,
  'Pima': 56303.28,
  'Querecho': 56695.44,
  'Choctaw': 27774.78,
  'Running': 27218.46,
  'Yangzhou': 25098.08,
  'Alabama': 28486.11,
  'Luristan': 32586.42,
  'Cusabo': 9495.16,
  'Safi': 13675.58,
  'Karbala': 48088.28,
  'Ilam': 22859.84,
  'Ferah': 42932.74,
  'Muskogee': 15684.2,
  'Tadla': 28696.63,
  'Zuwarah': 34748.38,
  'Hawran': 38634.6,
  'Kangra': 28520.59,
  'Natchitoches': 49467.42,
  'Natchez': 30141.07,
  'Figuig': 40489.74,
  'Mzab': 72990.4,
  'Tripolitania': 43616.68,
  'Darnah': 56377.85,
  'Acre': 9801.77,
  'Dash-i-Lut': 48654.57,
  'Sialkot': 18841,
  'Lhasa': 136576.52,
  'Cyrenaica': 46995.58,
  'Wasit': 25275.92,
  'Nakipa': 44499.52,
  'Tonkawa': 121109.05,
  'Langzhong': 71526.86,
  'Nanjing': 16557.79,
  'Zhenjiang': 8037.45,
  'Seri': 71906.85,
  'Marrakech': 17921.25,
  'Saoura': 102933.75,
  'Thubaqt': 28433.04,
  'Kerman': 82215.87,
  'Hanyang': 53818.37,
  'Satsuma': 8741.2,
  'Hitchiti': 32143.45,
  'Yasuj': 39194.34,
  'Himalaya': 54161.85,
  'Nyingchi': 132237.72,
  'Tademait': 233559.48,
  'Judea': 5412.47,
  'Sistan': 49407.61,
  'Bust': 40413.83,
  'Doaba': 27374.23,
  'Hefei': 39205.46,
  'Eyeish': 44466.97,
  'Bardiyah': 40839.45,
  'Kandahar': 40709.64,
  'Ouargla': 92823.38,
  'Punjab': 24220.58,
  'Jumano': 66973.75,
  'Haha': 15273.41,
  'Dumat': 137828.95,
  'Rafsanjan': 52751.46,
  'Derajat': 51290.56,
  'Shigatse': 150602.76,
  'Suma': 92355.56,
  'Samayah': 55665.1,
  'Khuzestan': 36293.72,
  'Tachieilu': 79322.69,
  'Sichuan Pendi': 101042.58,
  'Mocama': 12095.41,
  'Ouarzazate': 36823.55,
  'Ghadames': 73074.9,
  'Quetta': 45084.37,
  'Garhwal': 26288.1,
  'Shangai': 11064.56,
  'Biloxi': 16818.59,
  'Mobile': 12644.96,
  'Libya': 99986.8,
  'Sarvestan': 53248.84,
  'Shenquing': 70511.23,
  'Delta': 9424.22,
  'Diamientia': 10586.23,
  "Ma'an": 31449.45,
  'Yichang': 33463.82,
  'Al Karak': 11093.91,
  'Basra': 18921.53,
  'Multan': 39729.2,
  'Markam': 57917.8,
  'Yichuan': 34275.24,
  'Ningguo': 17145.87,
  'Sus': 35196.52,
  'Sirt': 57374.3,
  'Alexandria': 37274.28,
  'Negev': 9554.23,
  'Sirhind': 26730.13,
  'Anqing': 27415.92,
  'Adai': 23571.05,
  'Gaza': 9544.45,
  'Hangzhou': 17924.58,
  'Bayougoula': 12840.07,
  'Pensacola': 7763.98,
  'Chatot': 12086.07,
  'Chitimacha': 22140.1,
  'Timucua': 13027.26,
  'Bathlana': 29719.28,
  'Agadir': 28876.74,
  'Jufra': 129384.28,
  'Al Gharbia': 11663.88,
  'Sinai': 37706.39,
  'Kumaon': 19074.45,
  'Cochimi': 61571.73,
  'Yaqui': 91992.84,
  'Tuintsunde': 38254.61,
  'Apalachee': 15431.66,
  'Yustaga': 23305.62,
  'Rushehr': 37136.77,
  'Panipat': 17292.61,
  'Karankawa': 55626.75,
  'Huizhou Wu': 15030.32,
  'Suez': 13193.84,
  'Tayma': 80673.47,
  'Laristan': 56407.52,
  'Siwi': 30783.3,
  'Upper Doab': 36511.94,
  'Baisi Rayja': 46800.68,
  'Grand Erg': 253607.87,
  'Changsha': 53481.77,
  'Shanyin': 15265.03,
  'Ningbo': 10284.57,
  'Cairo': 12799.1,
  'Jabal Shammar': 143797.9,
  'Jangladesh': 50132.18,
  'Tindouf': 242881.16,
  'Central Sahara': 726005.64,
  'Kuwait': 16574.09,
  'Quhistan': 91926.01,
  'Cholistan': 33161.64,
  'Chenzhou': 32574.47,
  'Nanchang': 36716.19,
  'Concho': 79208.67,
  'Cacaxtes': 61709.38,
  'Asyut': 19504.78,
  'Bam': 64449.48,
  'Indus': 48991.02,
  'Tuat': 214216.95,
  'Chagai': 50777,
  'Tabouk': 87802.94,
  'Katehar': 28624.43,
  'Chaubusi Rayjas': 38332.41,
  'Poyang': 23617.04,
  'Al Watah': 67539.19,
  'Lijiang': 75786.68,
  'Hafar': 77669.28,
  'Arunachal': 85358.99,
  'Jinhua': 25524.18,
  'Seminole': 20489.33,
  'Bozhou': 32587.63,
  'Ras Gharib': 31621.92,
  'El Qatif': 56882.43,
  'Liangshan': 58945.66,
  'Zhenyuan': 71465.62,
  'Wenzhou': 17385.27,
  'East Sahara': 341321.41,
  'Minya': 24242.01,
  'Shekhawati': 22493.78,
  'Yuanling': 57595.83,
  'Sabha': 112162.46,
  'Ifni': 36122.31,
  'Upper Sind': 33134.97,
  'Mewat': 21352.59,
  "Ji'an": 49104.87,
  'Toboso': 77215.02,
  'Calusa': 24622.51,
  'Hormuz': 45662.45,
  'Bahreich': 17328.41,
  'Coahuila': 46385.9,
  'Ghat': 145171.88,
  'Kharan': 41508.85,
  'Katmandu': 28121.88,
  'Hkamti Long': 33449.34,
  'Umung': 32015.92,
  'Jianning': 27885.2,
  'Coahuilteco': 37894.17,
  'Jaisalmer': 39545.79,
  'Central Doab': 23761.78,
  'Bhutan': 37824.56,
  'The Canarias': 1644.99,
  'Bandar Langeh': 39323.89,
  'Limbuwan': 30794.33,
  'Koch': 13742.82,
  'Sadiya': 15845.66,
  'Guiyang': 77838.04,
  'Asyut South': 18462.17,
  'Makran': 77147.21,
  'Nagaur': 28917.76,
  'Oudh': 24527.42,
  'Gorakhpur': 23742.4,
  'Etawah': 20182.37,
  'Saguia el-Hamra': 152193.65,
  'Baluchistan': 59472.21,
  'Sehwan': 29437.09,
  'Hengyang': 61753.16,
  'Fuzhou': 22400.62,
  'Marwar': 52867.18,
  'Dundhar': 20327.39,
  'Tirhut': 28193.24,
  'Tepehuan': 183808.02,
  'Mayaimi': 22127.53,
  'Assam': 14956.55,
  'Adrar': 230826.94,
  'Bela': 33043.98,
  'Tingzhou': 22056.03,
  'Unaizah': 109854.46,
  'Laguneros': 52560.9,
  'Kargah': 46918.56,
  'Nile': 23376.49,
  'Medina': 61341.87,
  'Ajmer': 21307.82,
  'Gird': 30948.22,
  'Varanasi': 21694.35,
  'Tamanthi': 22749.57,
  'Ganzhou': 38966.01,
  'Borrado': 42143.68,
  'Ahaggar': 403495.88,
  'Nejd': 67762.52,
  'Koch Hajo': 19547.35,
  'Darrang': 24459.02,
  'Mong Kawng': 31343.15,
  'Huichol': 116513.53,
  'Cotoname': 45264.7,
  'Umarkot': 60073.1,
  'Barind': 28340.27,
  'Al Qusayr': 30082.27,
  'Dali': 69852.94,
  'Yunnan': 69682.23,
  'Lower Doab': 21594.63,
  'Jaunpur': 17079.12,
  'Bhagalpur': 41298.8,
  'Naga': 19587.21,
  'Guaycura': 38470.07,
  'Kalpi': 14829.43,
  'Guilin': 44083.94,
  'Al Hasa': 29762.95,
  'Qawasim': 10029.98,
  'Lower Sind': 29375.51,
  'Xiamen': 27410.46,
  'Djanet': 246735.21,
  'Qatar': 6715.56,
  'Meghalaya': 22136.47,
  'Gorwar': 23033.61,
  'Hadoti': 26247.27,
  'Bihar': 25325.77,
  'Guangxi': 55139.2,
  'Gauda': 23762.47,
  'Kachin': 33474.65,
  'Shiurwan': 39119.02,
  'Ibrim': 29850.58,
  'Chittor': 21204.66,
  'Bundelkhand': 35562.42,
  'Thaungdut': 20894.89,
  'Tajarhi': 103208.11,
  'Yanbu': 58059.63,
  "Ma'din Sulaym": 75963.68,
  'Kachar': 15810.18,
  'Chanderi': 17211.77,
  'Nasirabad': 14290.51,
  'Manipur': 18170.94,
  'Chaozhou': 22180.62,
  'Kelam': 6083.59,
  'Sylhet': 17990.54,
  'Huizhou': 44293.27,
  'Bahamas': 1784.66,
  'Taodeni': 169062.9,
  'Falaj': 67712.68,
  'Beni Yas': 14552.53,
  'Baghelkhand': 44882.9,
  'Dehong': 25040.66,
  'Wenshan': 43835.15,
  'Tamaulipas': 36834.72,
  'Suhar': 16642.95,
  'Mewar': 18603.26,
  'Yabrin': 35563.03,
  'Damin': 21570.11,
  "Pu'er": 47537.79,
  'Kutch': 33504.1,
  'Patan': 29399.61,
  'Jharkand': 56534.79,
  'Guangnan': 55853.38,
  'Middag': 16978.7,
  'Guachichil': 54225.14,
  'Bangala': 31733.34,
  'Dacca': 29753.8,
  'Malwa': 18226,
  'Guangzhou': 30120.39,
  'Halaib': 53835.66,
  'Abd Al-Qays': 20742.78,
  'Mahakoshal': 63265.57,
  'Tripura': 25861.92,
  'Rio de Oro': 113361.8,
  'Sagaing': 35883.88,
  'Hsenwi': 32727.43,
  'Namning': 44381.71,
  'Wuzhou': 38589.93,
  'XXX': 30314.11,
  'Nubia': 46371.87,
  'Nizwa': 59356.4,
  'Bhilsa': 30857.74,
  'Lakhnor': 20589.47,
  'Chin': 41548.78,
  'Hsipaw': 24670.28,
  'Hodh': 183441.38,
  'Tibesti': 128802.45,
  'Liwa': 20380.55,
  "Rub' al Khali": 431182.71,
  'Muscat': 15892.18,
  'Chittagong': 19004.06,
  'Taiwan': 3961.39,
  'Rewa Kantha': 21751.43,
  'Mandla': 24061.69,
  'Niger': 373233.74,
  'Mandu': 48502.49,
  'Rajkot': 21369.89,
  'Gujarat': 14096.48,
  'Sunderbans': 22341.33,
  'Cao Bang': 39370.69,
  'El Djouf': 176489.61,
  'Mecca': 43392.77,
  'Havana': 18622.41,
  'Sharqiyah': 51330.5,
  'Kathiawar': 15561.21,
  'Mahadeo': 28024.02,
  'Midnapore': 19330.34,
  'Macau': 700.12,
  'Camaguey': 19983.24,
  'Tamara': 78269.18,
  'Baroda': 12888.61,
  'Sambalpur': 29368.78,
  'Kyuakse': 39643.14,
  'Xishuan Banna': 30930.26,
  'Song La': 37564.66,
  'Lianzhou': 24487.86,
  'Hongkong': 1399.74,
  'Bhavnagar': 9322.12,
  'Leizhou': 24041.55,
  'Iziccoac': 17293.4,
  'Moron': 10357.62,
  'Truba': 61777.2,
  'Khurda': 41026.83,
  'Luang Namtha': 31447.8,
  'Mongnai': 43572.51,
  'Keng Tung': 41426.84,
  'Guamares': 33283,
  'Metztitlan': 18129.51,
  'Tadimekket': 136021.71,
  'Suakin': 71073.27,
  'Azawadd': 150653.31,
  'Shamal Darfur': 417606.03,
  'Wadi Halfa': 40020.62,
  'Sahra An Nubyah': 87888.45,
  'Jeddah': 44598.82,
  'Raipur': 30236.15,
  'Pagan': 35497.32,
  'Sayultecas': 32790.92,
  'Baglana': 22214.87,
  'Balasore': 16004.78,
  'Viet Bac': 20701.28,
  'Thang Long': 20220.81,
  'Girnar': 13070.8,
  'Khandesh': 28355.43,
  'East Berar': 34365.66,
  'Bayamo': 9562.13,
  'Ennedi': 382645.5,
  'Surat': 19029.98,
  'Ecab': 18792.97,
  'Baracoa': 18380.14,
  'Yucatan': 12070.3,
  'Arguin': 155445.25,
  'Arakan': 26189.72,
  'Ah Canul': 8711.45,
  'Mani': 17705.22,
  'West Berar': 42057.29,
  'Luang Prabang': 38070.96,
  'Tizapan': 20294.87,
  'Tohancapan': 11248.93,
  'Wusta': 85660.8,
  'Cuitzeo': 12663.14,
  'Huastec': 14071,
  'Azbin': 115306.52,
  'Maharastra': 33953.41,
  'Rajabara': 10729.64,
  'Xiankhouang': 29597.57,
  'Chanda': 22356.41,
  'Garjat': 30176.37,
  'Tarasco': 24476.07,
  'Tuliucan': 15638.77,
  'Tlaxcala': 11367.84,
  'Guantamano': 10732.01,
  'Bastar': 40089.37,
  'Mong Pai': 17212.35,
  'Nan': 59911.44,
  'Nghe An': 21837.85,
  'Asir': 57245.72,
  'North Konkan': 12042.04,
  'Apatzingan': 13833.74,
  'Borkou': 129612.81,
  'Dongola': 62833.23,
  'Hawaii': 7659.78,
  'Mexico': 16465.76,
  'Berber': 70350.28,
  'Srikakulam': 19706.19,
  'Colima': 18767.08,
  'Cutzamala': 23254.53,
  'Cuetlaxtlan': 10393.82,
  'Tortuga': 9632.06,
  'Pune': 38666.4,
  'Sandoway': 20517.06,
  'Chiang Mai': 32525.97,
  'Yazhou': 7169.63,
  'Hainan': 9604.83,
  'Campeche': 15921.77,
  'Magua': 12797.7,
  'Dhofar': 82962.82,
  'Mahur': 31422.06,
  'Wake': 9877.94,
  'Cholula': 8910.99,
  'Uaymil': 24936.54,
  'Bidar': 29582.87,
  'Maguana': 20714.3,
  'Tagant': 94595.36,
  'Ahmadnagar': 25939.42,
  'Toungoo': 32207.34,
  'Vientiane': 31670.53,
  'Tepeacac': 22376.1,
  'Agadez': 93473.92,
  "Dar Ja'al": 116151.5,
  'Mema': 47645.75,
  'Azawagh': 92799.35,
  'Jazan': 35934.91,
  'Ahqaf': 51783.17,
  'Gulbarga': 21081.51,
  'Zacatula': 14536.25,
  'Champutun': 26961.84,
  'Telingana': 44305.94,
  'Kalingandhra': 18277.59,
  'Thakhek': 25854.09,
  'Les Cayes': 14518.24,
  'Barahonas': 13773.27,
  'Timbuktu': 65824.5,
  'Karabara': 43570.05,
  'Hadramut': 135283.73,
  'Ha Tinh': 12890.09,
  'Teloloapan': 18185.18,
  'Tochtepec': 14011.18,
  'Trarza': 42821.54,
  'Chaul': 10968.19,
  'Xicallanco': 35198.6,
  'Kawar': 122785.37,
  'Samtoy': 13024.5,
  'Coixtlahuacan': 12918.52,
  'Jamaica': 4098.56,
  'Najran': 24617.14,
  'Nong Khai': 44983.06,
  'Cagayan': 28077.33,
  'Belize': 17026.2,
  'Puerto Rico': 4134.53,
  'Baghena': 101771.94,
  'Moulmein': 20466.04,
  'Colconda': 32637.69,
  'Sukthothai': 26331.95,
  'Nongbua Lamphu': 21444.41,
  'Cihuatlan': 9674.79,
  'Coyolapan': 16501.22,
  'Mixe': 16738.57,
  'Taka': 62637.08,
  'Mahra': 74812.82,
  'Ayeyarwady': 30260.32,
  'Pegu': 19427.38,
  'Massawa': 22411.64,
  'Desh': 29819.49,
  'Bijapur': 33902.24,
  'Tlapanec': 15496.97,
  'Djado': 20907.14,
  'Yopitzinco': 13676.15,
  'Tehuantepec': 21115.24,
  'Petén': 30569.63,
  'Ader': 70381.04,
  'Konaseema': 21742.21,
  'Chiapas': 31361.46,
  'Gao': 43471.32,
  'Hamasien': 33941.86,
  "Sana'a": 51703.51,
  'Malvana': 9489.12,
  'Savannakhet': 26210.23,
  'Zarmadanga': 65613.04,
  'Al Jawf': 39516.91,
  'Martaban': 18605.95,
  'Binh Tri Thien': 10516.89,
  'Mixtec': 15753.28,
  'Zapotec': 19584.97,
  'Phitsanulok': 24152.14,
  'Termes': 73063.15,
  'Bara': 29903.54,
  'Itesan': 58433.9,
  'Phra Bang': 19640.77,
  'Chaiyaphum': 29152.89,
  'Xocnochco': 26300.71,
  'Soba': 26493.45,
  'Pangasinan': 16729.03,
  'Cayor': 54573.1,
  'Damagaram': 38449.46,
  'Kanem': 63713.19,
  'Mocha': 52892.69,
  'Velanadi': 18739.87,
  'Guadelopue': 2081.8,
  'Tekrur': 27618.79,
  'Hombori': 42846.16,
  'Champassak': 46718.79,
  'Chacujal': 23550.83,
  'Massina': 39838,
  'Kordofan': 135553.07,
  'Butana': 81189.71,
  'Savanaur': 26938.17,
  'Raichur Doab': 22616.83,
  'Kurnool': 20726.31,
  'Khorat': 41931.25,
  'Khukhan': 37624.22,
  'Amaravati': 19429,
  'Guatemala': 32550,
  'Haayre': 27421.34,
  'Damasak': 53218.39,
  'Taqali': 82954.2,
  'Kanara': 10174.11,
  'Ayutthaya': 38514.19,
  'Honduras': 24174.56,
  'Tondo': 19253.2,
  'Chortli': 37727.91,
  'Wolof': 40157.2,
  'Al-Junaynah': 108090.73,
  'Ratchaburi': 28345.75,
  'Kala': 24470.87,
  'Yao': 78303.01,
  'Mendefera': 31774.97,
  'Micronesia': 7011.99,
  'Tajura': 35228.47,
  'Kinda': 67757.04,
  'Kosta': 15138.13,
  'Olancho': 29511.83,
  'Wagadu': 42776.03,
  'Segu': 59539.52,
  'Aribanda': 28375.75,
  'Kosti': 27750.48,
  'Gezira': 49979.62,
  'Vijayanagar': 24131.53,
  'Iximche': 19004.95,
  'Rayalaseema': 27413.31,
  'Liptako': 41104.03,
  'Ouaddai': 204515.93,
  'North Kanara': 13550.34,
  'Dallol': 46197.89,
  'Tavoy': 15225.52,
  'Mosquito': 27249.35,
  'Galam': 46117.19,
  'Tay Nguyen': 36405.76,
  'Manila': 16159.39,
  'Uluas': 43648.89,
  'Bambuk': 38651.86,
  'Gobir': 35935.57,
  'Aksum': 21981.97,
  'Vijaya': 12548.08,
  'Muniyo': 26550.66,
  'Tigre': 21622.56,
  'Stung Treng': 27536.24,
  'Pipil': 19526.69,
  'Jenne': 28261.56,
  'Daura': 32050.34,
  'Semien': 28782.22,
  'Malenadu': 23424.81,
  'Rayong': 39997.21,
  'Lenca': 16978.09,
  'Yatenga': 40889.88,
  'Dendi': 25349.84,
  'Aden': 24170.6,
  'Battambang': 24289.26,
  'Siem Reap': 41407.23,
  'Bikol': 12976.31,
  'St. Lucia': 1558.34,
  'Do': 38098.79,
  'Nicaragua': 21334.97,
  'Arcot': 19429.01,
  'Tondainadu': 9703.02,
  'Kebbi': 36820.97,
  'West Darfur': 146794.69,
  'Bilanga': 27700.6,
  'Zamfara': 51161.88,
  'Bornu': 54143.26,
  'Bagirmi': 78341.74,
  'Morasanadu': 22647,
  'Gambia': 8209.29,
  'Kobbe': 89297.2,
  'Dembiya': 28756.77,
  'South Kanara': 14093.8,
  'Kratie': 20489.77,
  'Bendugu': 38036.62,
  'Biram': 35526.7,
  'Bedde': 36656.44,
  'Angot': 27751.85,
  'Barbados': 1191.71,
  'Sibiridugu': 46260.82,
  'Gurma': 36118.79,
  'Katsina': 34172.66,
  'Sennar': 56470.42,
  'Lasta': 24775.08,
  'Phetchaburi': 17610.55,
  'Siine': 19236.61,
  'Joma': 30660.77,
  'Wagadugi': 24619.79,
  'Kotoko': 49358.24,
  'Mysore': 21481.79,
  'Kauthara': 11363.06,
  'Kano': 32647.91,
  'Awsa': 38239.56,
  'Dar Nuba': 105935.17,
  'Tenasserim': 15782.27,
  'Curacao': 3573.32,
  'Maroua': 44790.19,
  'Gabu': 30163.2,
  'Kantor': 35967.68,
  'Gonder': 16120.97,
  'Djibouti': 19854.44,
  'Coromandel': 14717.25,
  'Managua': 25293.07,
  'Wasuju': 46479.47,
  'Borgu': 34656.5,
  'Kongu': 32490.54,
  'Udong': 33818.92,
  'Visayas': 22440.08,
  'Futa Jallon': 96638.95,
  'Gingee': 12462.87,
  'Phnom Penh': 37757.53,
  'Guajira': 26219.19,
  'Malabar': 17285.89,
  'Coro': 40009.39,
  'Lobi': 30229.28,
  'Tenkodogo': 30699.15,
  'Fashoda': 88524.3,
  'Agew': 41233.39,
  'Hafun': 22213.1,
  'Prei Nokoi': 25417.94,
  'Gojjam': 25851.55,
  'Wollo': 18886.11,
  'Panduranga': 12846.36,
  'Beafada': 45606.18,
  'Zazzau': 44701.28,
  'Yawuri': 36293.62,
  'Rano': 42153.98,
  'Bosaso': 20285.1,
  'Carnatic': 14119.27,
  'Panay': 18729.05,
  'Marghi': 28848.75,
  'Zeila': 19304.59,
  'Maracaibo': 38617.29,
  'Las Khoray': 22521.85,
  'Magdalena': 37457.86,
  'Dagbon': 43610.76,
  'Atakora': 28347.94,
  'Bauchi': 37059.25,
  'Chari': 111870.71,
  'Ankober': 32999.98,
  'Sanaag': 19476.56,
  'Palawan': 9079.73,
  'Nicoya': 31415.81,
  'Altagracia': 24336.87,
  'Bonoman': 66104.83,
  'Moshi': 28619.25,
  'Central Africa': 333578.77,
  'Mora': 37935.27,
  'Tanjore': 14540.45,
  'Caracas': 24049.42,
  'Asosa': 33526.28,
  'Berbera': 15232,
  'Chaiya': 20017.08,
  'Prek Ruisey': 17580.96,
  'Cumana': 25573.81,
  'Trinidad': 1639.15,
  'Bagoe': 37457.12,
  'Bahr el Ghazal': 189139.45,
  'Kochin': 12918.97,
  'Cartagena': 50546.13,
  'Sierra Leone': 149008.16,
  'Nupe': 43207.82,
  'Shoa': 38458.33,
  'Hargeisa': 25556.74,
  'Damot': 22933.53,
  'Madurai': 22900.07,
  'Prek Khmao': 16604.5,
  'Harer': 29519.47,
  'Chorotega': 18967.65,
  'Llanos': 63052.91,
  'Orinoco Delta': 34004.37,
  'Abomey': 28089.97,
  'Ketu': 16316.23,
  'Wukari': 56832.6,
  'Qardho': 28672.73,
  'Kong': 44140.69,
  'Oyo': 45054.52,
  'Logone': 41095.95,
  'Togdheer': 60825.9,
  'South Sudan': 149572.27,
  'Zaraza': 53771.74,
  'Uyapari': 28521.21,
  'Adamaoua': 136538.23,
  'Veraguas': 30050.03,
  'Venad': 11900.2,
  'Thalang': 20335.25,
  'Butuan': 21711.34,
  'Panama': 35024.77,
  'Pindinga': 41135.88,
  'Degehabur': 52685.3,
  'Tirunelveli': 8092.42,
  'Vanni': 13032.08,
  'Guayana': 86663.52,
  'Worodugu': 115348.33,
  'Yola': 25070.27,
  'Nuer': 112930.58,
  'Illubabor': 32811.87,
  'Ligore': 18635.01,
  'Chiancon': 82379.75,
  'Barinas': 57328.48,
  'Gyaaman': 45871.14,
  'Kumasi': 63635.46,
  'Ife': 45990.4,
  'Arsi': 26750.29,
  'Garoowe': 35264.44,
  'Merida': 31265.59,
  'Togo': 28780.45,
  'Kandy': 24337.22,
  'Darien': 29145.53,
  'Essequibo': 37628.83,
  'Ouham': 88282.86,
  'Fazughli': 26667.56,
  'Karou': 37471.72,
  'Ifat': 30056.17,
  'Haud': 62085.29,
  'Tagoloan': 22120.23,
  'Idah': 47680.25,
  'Dawaro': 61983.67,
  'Kefa': 52764.29,
  'Antioquía': 46879.82,
  'Angostura': 100559.32,
  'Tagloc': 12570.36,
  'Ceylon': 16679.99,
  'Apure': 50412.55,
  'Upper Orinoco': 222790.42,
  'Whydah': 15182.87,
  'Ondo': 19184.99,
  'Bouar': 134109.47,
  'Welayta': 64319.13,
  'Maguindanae': 22649.96,
  'Grain Coast': 48901.19,
  'Denkyira': 31223.75,
  'Ogaden': 87188.43,
  'Mayertern': 32337.57,
  'Gold Coast': 18704.36,
  'Ijebu': 24896.88,
  'Pirara': 130323.06,
  'Demerara': 37205.34,
  'Calabar': 38876.92,
  'Borena': 91663.75,
  'Bonny': 64402.37,
  'Bamenda': 41110.59,
  'Sabah': 44908.7,
  'Ivory Coast': 100260.65,
  'Hobyo': 12726.89,
  'Pattani': 12564.6,
  'Tunja': 51906.13,
  'Bangui': 66456.55,
  'Choco': 33912.03,
  'Kedah': 12103.84,
  'Afder': 65582.95,
  'El Buur': 42575.39,
  'Lahad Datu': 33143.5,
  'Mariquita': 27641.69,
  'Paramaribo': 34499.28,
  'Cameroon': 256650.3,
  'Kelantan': 15846.03,
  'Puerto Carreno': 161379.69,
  'Cape Coast': 19866.93,
  'Juba': 117565.68,
  'Cayenne': 83897.5,
  'Perak': 19619.89,
  'Terengganu': 11592.92,
  'Aceh': 12788.75,
  'Bogota': 12687.7,
  'Roraima': 193887.64,
  'Meregh': 13806.47,
  'Suriname': 108870.39,
  'Kisangani': 375105.3,
  'Pasai': 9023.16,
  'Inner Kongo': 462397.6,
  'Beledweyne': 41335.02,
  'Neiva': 47429.44,
  'Ajuuraan': 55820.16,
  'Peureulak': 13213.56,
  'Brunei': 6952.73,
  'Meta': 70030.52,
  'Pahang': 36260.6,
  'Cauca': 43397.53,
  'Nyanza': 144999.61,
  'Oiapoque': 66545.26,
  'Sibu': 82844.09,
  'Tana': 245063.49,
  'Gayo': 21961.86,
  'Warsheikh': 14937.86,
  'Tarakan': 29275,
  'Acholiland': 128028.78,
  'Pontianak': 25785.69,
  'Bulungan': 37347.57,
  'Fernando Po': 1608.91,
  'Afgooye': 31896.74,
  'Aru': 13297.99,
  'Selangor': 12560.34,
  'Likouala': 122077.04,
  'Caqueta': 139979.74,
  'Mogadishu': 17479.63,
  'Batak': 24838.12,
  'Popayan': 28323.68,
  'Guaviare': 104618.53,
  'Malacca': 10818.04,
  'Guyana': 343851.72,
  'Bardera': 44838.65,
  'Barcelos': 154904.24,
  'Ogooue': 157247.76,
  'Rokan': 21024.92,
  'Johor': 12145.5,
  'Berau': 28556.99,
  'Northern Amazonas': 403754.79,
  'Merca': 11202.5,
  'Ternate': 3648,
  'Equatorial Guinea': 24289.19,
  'Sarawak': 27358.74,
  'Tucujulandia': 48202.97,
  'Borneo': 166267.93,
  'Uganda': 172072.79,
  'Menade': 4877.36,
  'Esmeraldas': 31273.86,
  'Singapore': 1814.07,
  'Halmahera': 7057.76,
  'Owando': 92281.43,
  'Barawa': 12850.39,
  'Pariamay': 22743.94,
  'Siak': 32626.66,
  'Kivu': 110225.56,
  'Palu': 28372.71,
  'Quito': 51927.04,
  'Gabon': 112348.55,
  'Gorontalo': 13854.33,
  'Kismayo': 24954.06,
  'Kutei': 27651.68,
  'Canelos': 73685.41,
  'Maniema': 179650.55,
  'Inner Colombia': 121298.9,
  'Minangkabau': 26670.19,
  'Iquitos': 146580.38,
  'Indragiri': 32352.12,
  'Marajo': 41122.31,
  'Muturu': 106879.9,
  'Sukadane': 39579.14,
  'Samarinda': 24058.01,
  'Pate': 14197.01,
  'Jambi': 54148.16,
  'Irian': 50576.28,
  'Grao Para': 68745.27,
  'Pose': 24280.92,
  'Guayaquil': 36825.63,
  'Bandundu': 120386.66,
  'Chisimayo': 10738.05,
  'Alcantara': 63413.08,
  'Mwanza': 59671.67,
  'Malindi': 46810.82,
  'Kilimanjaro': 123703.62,
  'Para': 211488.52,
  'Mayombe': 106151.99,
  'Rwanda': 22912.01,
  'Sampit': 42914.81,
  'Barito': 35507.87,
  'Banjarmasin': 54425.58,
  'Kasai Oriental': 184087.08,
  'Bangka': 7458.29,
  'Maoke': 179978.9,
  'Quijos': 85545.32,
  'Manaus': 212007.96,
  'Sula': 5845.06,
  'Santa Ana': 58949.85,
  'Palopo': 28646.93,
  'Mombasa': 34123.54,
  'South Pagaryung': 15597.87,
  'Palembang': 41937.58,
  'Bone': 36803.6,
  'Fak-Fak': 57838.45,
  'Maranhao': 59113.49,
  'Kasai': 196415.13,
  'Burundi': 29123.78,
  'Belitung': 3586.79,
  'Ceara': 93826.03,
  'Madang': 117212.32,
  'Wankapampa': 32680.91,
  'Tucurui': 113923.02,
  'Parnaiba': 50529.61,
  'Nauru': 3395.55,
  'Ceram': 12486.36,
  'Kinshasa': 48760.78,
  'Benkulen': 20663.06,
  'Buru': 3503.84,
  'Jurua': 513721.47,
  'Tumbes': 12035.18,
  'Alpercatas': 95774.69,
  'Loango': 27227.85,
  'Ujiji': 116345.47,
  'Tabora': 121716.42,
  'Tanga': 37538.32,
  'Asmat': 54535.36,
  'Maynas': 68004.29,
  'Lampung': 42180.2,
  'Makassar': 22343.48,
  'Timon': 49693.48,
  'Xingu': 340340.26,
  'Mbata': 122558.33,
  'Rio Madeira': 209364.93,
  'Mahe': 4868.89,
  'Rabaul': 27505.44,
  'Mbamba': 39401.53,
  'Chachapoyas': 38182.87,
  'Rio Grande': 44869.48,
  'Dodoma': 98240.96,
  'Buton': 6454.83,
  'Piwra': 33260.67,
  'Kalemie': 191486.71,
  'Tocantins': 98659.24,
  'Cajamarca': 42723.78,
  'Oeiras': 121955.9,
  'Daru': 89999.06,
  'Southern Amazonas': 329488.88,
  'Crato': 57396.34,
  'Moyobamba': 79640.91,
  'Bagamoyo': 28132.23,
  'Kerema': 78395.07,
  'Aru Moluccan"': 3128.6,
  'Yos Sudarso': 72309.42,
  'Lae': 54910.7,
  'Tucume': 19403.36,
  'Paraiba': 24658.51,
  'Ndongo': 220910.92,
  'Kongo': 82586.2,
  'Boroborema': 45048.53,
  'Banten': 7562.8,
  'Sunda': 8560.35,
  'Pisqupampa': 40253.54,
  'Pastos Bons': 68012.04,
  'Cirebon': 11720.28,
  'Parnagua': 100998.54,
  'Mzizima': 35242.81,
  'Surabaya': 18201.05,
  'Solomon Islands': 145644.45,
  'Kolwezi': 171024.06,
  'Sukabumi': 10703.39,
  'Chanchan': 32426.79,
  'Lunda': 169914.18,
  'Demak': 6121.56,
  'Acre State': 147047.9,
  'Priangan': 10502.89,
  'Yamdena': 327.14,
  'Itamaraca': 24214.19,
  'Mbeya': 176709.73,
  'Mataram': 11691.47,
  'Kediri': 13854.91,
  'Pambu': 65981.23,
  'Karia': 7745.02,
  'Kilwa': 55257.51,
  'Blambangan': 16029.72,
  'Rondonia': 121077.64,
  'Papua': 57411.05,
  'Ucayali': 111403.59,
  'Zambia': 213530.19,
  'Bali-Lombok': 1600.88,
  'Pernambuco': 31046.82,
  'Lombok': 2983.35,
  'Sumbawa': 7754.54,
  'Flores': 9478.04,
  'Huaraz': 35533.66,
  'Huanuco': 34532.79,
  'Cerejeiras': 148563.6,
  'Timor': 10636.99,
  'Barra': 96626.89,
  'Natividad': 90640.52,
  'Katanga': 120961.85,
  'Luapula': 65434.51,
  'Jeremoabo': 34553.07,
  'West Timor': 10484.14,
  'Sergipe': 32033.68,
  'Malawi': 54371.75,
  'Lindi': 42497.68,
  'Chimbote': 17016.18,
  'Conceicao': 103531.76,
  'Benguela': 220215.74,
  'Sumba': 3778.18,
  'Madre de Dios': 119135.06,
  'Rio das Mortes': 172145.39,
  'Campo Largo': 93836.61,
  'Inhambupe': 66153.95,
  'Tarma': 30858.29,
  'San Joaquin': 94150.91,
  'Diamantino': 130706.16,
  'Mozambique': 119050.72,
  'Christmas Island': 2817.72,
  'Kokowarra': 144199.99,
  'Vila Bela': 145105.4,
  'Moxico': 222278.49,
  'Vanuatu': 5278.02,
  'Quero': 79911.18,
  'Larrakia': 175242.91,
  'Lima': 25937.32,
  'Bahia': 23377.05,
  'Solwezi': 187215.5,
  'Niassa': 138878.52,
  'Huambo': 109554.4,
  'Paratinga': 41278.13,
  'Huancavelica': 23976.05,
  'Cuzco': 33293.27,
  'Rio Contas': 126632.67,
  'Ndola': 106388.62,
  'Yolngu': 233188.37,
  'Boina': 204344.18,
  'Arrial dos Couros': 99222.65,
  'Huamanga': 40288.15,
  'Ilheus': 41129.28,
  'Comores': 1274.36,
  'Chiquitos': 189112.76,
  'Nazca': 48274.58,
  'Goias': 114255.9,
  'Ayaviri': 48406.16,
  'Macaya': 30615.99,
  'Mato Caceres': 107644.22,
  'Chewa': 36735.31,
  'Ngarinyin': 223124.87,
  'Moxos': 65909.46,
  'Cuando Cubango': 207994.7,
  'Chuquiabo': 41403.34,
  'Xeres': 122920.82,
  'Zumbo': 57860.26,
  'Santo Antonio da Manga': 79485.15,
  'Barwe': 47061.13,
  'Angoche': 47971.4,
  'Camana': 45131.32,
  'Shangwe': 40749.28,
  'Diamentina': 72274.85,
  'Lusaka': 140507.19,
  'Puno': 24826.75,
  'Caranga': 70496.82,
  'St. Helena': 3272.69,
  'Quelimane': 65361.4,
  'Luziana': 57387.62,
  'Porto Seguro': 49094.93,
  'Serro': 79037.78,
  'Urungwe': 46821.34,
  'Kurtjar': 145020.66,
  'Mato Grosso': 79072.55,
  'Mudburra': 343909.97,
  'Djirbalngan': 110726.38,
  'Nyikina': 206343.87,
  'Arequipa': 34537.44,
  'Tiahuanaco': 28875.4,
  'Tete': 53751.23,
  'Antananarivo': 162310.36,
  'Charcas': 23952.43,
  'Vila Boa': 74763.13,
  'Fiji': 10355.63,
  'Santa Cruz de la Sierra': 43615.05,
  'Fuerte Borbon': 171550.81,
  'Butua': 46779.84,
  'Sena': 57884.42,
  'Mbaracayu': 97101.01,
  'Greater Namaqualand': 189840.87,
  'Oshana': 177180.41,
  'Okavango': 136804.2,
  'Menabe': 213290.99,
  'Oruro': 37056.2,
  'Arica': 22755.92,
  'Minas Gerais': 87992.37,
  'Ngamiland': 152522.27,
  'Matabeleland': 107257.88,
  'Buhera': 41489.73,
  'Sofala': 56390.26,
  'Western Australia': 689124.81,
  'Warluwarra': 325330.68,
  'Caracara': 30673.02,
  'Espirito Santo': 61041.19,
  'Corumba': 108562.34,
  'Araxas': 90679.15,
  'Ofaie': 135817.09,
  'Biri': 126523.34,
  'Vila Rica': 39581.39,
  'Sucre': 38271.55,
  'Zimbabwe': 36237.57,
  'Uteve': 43942.94,
  'Iquique': 27348.92,
  'Potosi': 25163.16,
  'Kalanga': 116804.84,
  'Yirandali': 178444.23,
  'Quillacas': 33355.85,
  'Chaco Boreal': 115187.23,
  'Nyamal': 271025.16,
  'Araquara': 96907.94,
  'New Caledonia': 6239.04,
  'Chichas': 36160.29,
  'Tarija': 65330.89,
  'Campinas': 65631.48,
  'Sao Joao del Rel': 67614.92,
  'Calama': 44281.49,
  'Réunion': 1983.36,
  'Inhambane': 96212.61,
  'Kalahari': 210567.14,
  'Damaraland': 158831.57,
  'Sao Tome': 32475.56,
  'Melodia': 106463.98,
  'Uluru': 256404.81,
  'Rio de Janeiro': 18787.5,
  'Santa Catalina': 57188.94,
  'Watjarri': 295425.09,
  'Jujuy': 81287.41,
  'Limpopo': 107981.44,
  'Concepcion': 40042.87,
  'Santo Amaro': 19697.58,
  'Kuungkari': 226797.44,
  'Gubbi Gubbi': 68741.59,
  'Botswana': 86997.08,
  'Sao Vicente': 56144.28,
  'Atacama': 43061.45,
  'Guayra': 90113.24,
  'Central Australia': 634372.49,
  'Castro': 62968.9,
  'Barunggam': 140443.84,
  'Chaco Central': 83488.22,
  'Delagoa Bay': 73990.16,
  'Wawula': 531727.41,
  'Itenines': 48948.37,
  'Gauteng': 97530.76,
  'Copiapo': 93962.16,
  'Tucuman': 104830.36,
  'Matara': 63754.15,
  'Mpumalanga': 70178.49,
  'Santana': 26216.33,
  'Karas': 158056.85,
  'Itapua': 28447.47,
  'Khoikhoi': 108908.96,
  'Santiago del Estero': 96929.11,
  'Chaco Austral': 156983.02,
  'Griqualand': 158768.87,
  'Santiago': 34429.1,
  'Misiones': 46800.83,
  'Wangkumara': 199896.23,
  'Catamarca': 82970.56,
  'Santa Catarina': 108113.27,
  'Swaziland': 14568.38,
  'Bundjalung': 135042.73,
  'Kamilaroi': 257095.4,
  'Zululand': 30523.31,
  'Highveld': 125617.34,
  'Tape': 86334.37,
  'Corrientes': 60262.31,
  'Coquimbo': 61520.27,
  'Santa Tecla': 108839.48,
  'Natal': 42223.56,
  'La Rioja': 58276.95,
  'Lesser Namaqualand': 93252.74,
  'Andyamathanha': 258618.74,
  'Patos': 82863.52,
  'Lesotho': 29761.42,
  'Kalaamaya': 141530.1,
  'Yareyu': 49010.33,
  'Cuyo': 71401.73,
  'Great Karoo': 109654.93,
  'Wadjuk': 168175.87,
  'Chepes': 64974.79,
  'Roggeveld': 81410.75,
  'Transkei': 69911.99,
  'Quisquiscate': 100041.8,
  'Eora': 86537.55,
  'Parana': 77032.21,
  'Nullarbor': 158534.26,
  'Salto': 47180.6,
  'Wiradjuri': 172669.12,
  'Wudjari': 143359.82,
  'Nawu': 87065.41,
  'Graaff-Reinet': 43181.04,
  'Uruguay': 41898.36,
  'Pincunmapu': 60724.82,
  'Banda Oriente': 31735.04,
  'Mendoza': 113382.64,
  'San Luis': 40335.69,
  'Wergaia': 192911.96,
  'Rosario': 46434.81,
  'Little Karoo': 50181.65,
  'Kaurna': 77418.11,
  'Cape': 50411.17,
  'Pampas': 57669.03,
  'Colonia': 18604.79,
  'Montevideo': 28494.05,
  'Rio de la Plata': 40605.24,
  'Whangarei': 11099.69,
  'Querandi': 58404.84,
  'Yuin': 86936.55,
  'Chiquiyami': 61178.69,
  'Gunditjmara': 96740.37,
  'Chanar': 42809.06,
  'Salinas Grande': 94883.48,
  'Huillimapu': 46885.44,
  'Woiworung': 57175.31,
  'Olavarria': 48609.62,
  'Serranos': 38529.67,
  'Kirikiriroa': 20505.22,
  'Rio Negro': 82001.71,
  'Pehuenmapu': 53220.66,
  'Chiloe': 78991.52,
  'Wairoa': 28915.29,
  'Carmen': 53871.78,
  'Tehuelmapu': 86175.67,
  'Taranaki': 17916.24,
  'Ahuriri': 21275.99,
  'Poya': 54100.52,
  'Bahia Blanca': 37694.87,
  'Waitaha': 54418.63,
  'Paredarerme': 59106.54,
  'Chubut': 104999.14,
  'Rawson': 81822.82,
  'Aysen': 70810.7,
  'Timaru': 57042.56,
  'Teush': 94942.9,
  'Aorangi': 31231.49,
  'Comodoro Rivadavia': 61335.71,
  'Patagonia Occidental': 75653.36,
  'Patagonia Oriental': 109531.62,
  'Falklands': 35280.20,
  'Tierra del Fuego': 62082.61,
  'South Georgia': 21406.03
}

export const adjacent = [
  [12, 13, 16, 17], [3, 15, 23, 51], [4, 18, 22], [1, 23, 27], [2, 5, 22, 33, 35], [4, 6, 32, 35, 37, 46], [5, 7, 19, 37, 38], [6, 8, 19, 34, 36], [7, 9, 36], [8, 10, 36, 48], [9, 11, 48], [10, 48], [0, 13, 17, 24, 25, 28, 40], [0, 12, 24], [], [1, 43, 51, 65], [0, 17, 39, 42], [0, 12, 16, 25, 39], [2, 22, 26, 44], [6, 7, 34, 38], [21, 47], [20, 47, 80], [2, 4, 18, 33, 44], [1, 3, 27, 45, 51], [12, 13, 40, 43, 53, 72], [12, 17, 28, 39, 50], [18, 29, 44, 68, 84], [3, 23, 29, 45, 60, 77], [12, 25, 40, 49, 74], [26, 27, 60, 68, 106], [31], [30], [5, 35, 46, 66], [4, 22, 35, 44, 63, 67], [7, 19, 36, 38, 52, 75], [4, 5, 32, 33, 66, 67], [7, 8, 9, 34, 48, 52], [5, 6, 38, 46, 75, 85], [6, 19, 34, 37, 75], [16, 17, 25, 42, 50, 62, 64], [12, 24, 28, 49, 72, 87], [72, 87, 90], [16, 39, 61, 62], [15, 24, 53, 65, 73], [18, 22, 26, 33, 63, 84, 92], [23, 27, 51, 77, 98, 109], [5, 32, 37, 66, 81, 85, 96], [20, 21, 80], [9, 10, 11, 36, 141], [28, 40, 74, 87], [25, 39, 64, 89, 97], [1, 15, 23, 45, 65, 98, 105, 107], [34, 36, 75], [24, 43, 72, 73, 99, 102, 103], [55, 79, 83, 111], [54, 56, 83, 108, 114, 115, 143], [55, 57, 125, 130, 143, 150, 152, 156], [56, 113], [], [], [27, 29, 77, 106, 133, 146], [42, 62, 86, 91], [39, 42, 61, 64, 86, 88], [33, 44, 67, 92, 101, 124], [39, 50, 62, 88, 89], [15, 43, 51, 73, 93, 107, 118], [32, 35, 46, 67, 81, 128, 134], [33, 35, 63, 66, 124, 128], [26, 29, 84, 106, 120], [], [94, 136, 212], [], [24, 40, 41, 53, 90, 100], [43, 53, 65, 93, 99], [28, 49, 87], [34, 37, 38, 52, 85, 119], [], [27, 45, 60, 109, 133], [], [54, 83, 111], [21, 47], [46, 66, 96, 134, 135, 160], [615, 661], [54, 55, 79, 108], [26, 44, 68, 92, 120], [37, 46, 75, 96, 119, 135], [61, 62, 88, 91, 110, 129], [40, 41, 49, 74, 90], [62, 64, 86, 89, 116, 129, 137], [50, 64, 88, 97, 116, 123], [41, 72, 87, 100], [61, 86, 110], [44, 63, 84, 101, 120, 151, 175, 183], [65, 73, 99, 118, 127], [70, 104, 136], [], [46, 81, 85, 135], [50, 89, 116, 123], [45, 51, 105, 109, 149], [53, 73, 93, 103, 127, 140, 148, 154], [72, 90, 102, 117], [63, 92, 124, 151], [53, 100, 103, 117, 126], [53, 99, 102, 126, 140], [94, 216], [51, 98, 107, 132, 149], [29, 60, 68, 120, 146], [51, 65, 105, 118, 132, 168, 173, 180], [55, 83, 115], [45, 77, 98, 133, 149, 174, 206, 208], [86, 91], [54, 79], [], [57, 169, 171], [55, 143, 164], [55, 108], [88, 89, 97, 123, 137], [100, 102, 122, 126, 139], [65, 93, 107, 127, 168], [75, 85, 135, 207, 249, 263, 281], [68, 84, 92, 106, 146, 175, 197], [122, 142], [117, 121, 138, 142], [89, 97, 116, 155], [63, 67, 101, 128, 151, 188, 222], [56, 130, 156, 215], [102, 103, 117, 139, 140, 153, 159], [93, 99, 118, 148, 168, 177], [66, 67, 124, 134, 188], [86, 88, 137], [56, 125, 150, 215], [], [105, 107, 149, 173, 200], [60, 77, 109, 146, 174, 218, 244], [66, 81, 128, 160, 188, 227], [81, 85, 96, 119, 160, 207], [70, 94, 212, 216, 318, 341, 422], [88, 116, 129, 155, 170], [122, 139, 142, 158, 166], [117, 126, 138, 158, 159, 166], [99, 103, 126, 153, 154], [48], [121, 122, 138, 158, 161], [55, 56, 114, 152, 164, 184, 214, 247, 298, 302], [162, 165, 179, 198], [], [60, 106, 120, 133, 197, 218, 252, 271, 275], [], [99, 127, 154, 172, 177], [98, 105, 109, 132, 200, 208], [56, 130, 152, 215, 253], [92, 101, 124, 183, 222], [56, 143, 150, 214, 253, 299], [126, 140, 154, 159, 182, 202], [99, 140, 148, 153, 172, 187, 202], [123, 137, 170, 190, 195], [56, 125, 181, 215, 283], [], [138, 139, 142, 161, 166, 176, 191, 193, 203, 204], [126, 139, 153, 166, 182, 191, 205], [81, 134, 135, 207, 227, 296], [142, 158, 176], [144, 179], [176, 186, 192], [114, 143, 184], [144], [138, 139, 158, 159, 191], [189], [107, 118, 127, 177, 180, 196, 211], [113, 171, 181, 231, 259], [137, 155, 195], [113, 169, 178, 219], [148, 154, 177, 187, 196, 221, 226], [107, 132, 180, 200, 213], [109, 133, 206, 244], [92, 120, 183, 197, 293], [158, 161, 163, 192, 193], [127, 148, 168, 172, 196], [171, 219, 223], [144, 162, 198, 201], [107, 168, 173, 211, 213, 230, 246], [156, 169, 231, 283, 325], [153, 159, 202, 205, 262, 269], [92, 151, 175, 222, 287, 293], [143, 164, 247], [], [163, 192, 235, 237], [154, 172, 202, 221, 250], [124, 128, 134, 222, 287, 327, 353], [167, 217], [155, 195], [158, 159, 166, 204, 205, 240], [163, 176, 186, 193, 229, 237], [158, 176, 192, 203, 229], [], [155, 170, 190], [168, 172, 177, 211, 226], [120, 146, 175, 252, 293, 391, 404], [144, 179, 201, 228], [234], [132, 149, 173, 208, 213, 270, 317], [179, 198, 209, 228], [153, 154, 182, 187, 250, 269], [158, 193, 204, 229, 268], [158, 191, 203, 240, 268, 292], [159, 182, 191, 240, 262], [109, 174, 208, 244, 251], [119, 135, 160, 263, 296, 297], [109, 149, 200, 206, 251, 317], [201, 228, 248], [239], [168, 180, 196, 226, 230, 257], [70, 136, 341, 342], [173, 180, 200, 246, 270], [143, 152, 298, 299], [125, 130, 150, 156, 253, 283, 328, 358, 361], [104, 136, 264, 310, 318, 356], [189, 233, 236, 238], [133, 146, 244, 271, 370], [171, 178, 223, 259, 345, 395, 436], [224, 260], [172, 187, 226, 250, 274], [124, 151, 183, 188, 287], [178, 219, 332, 345], [220, 260, 300, 306], [], [172, 196, 211, 221, 257, 274], [134, 160, 296, 327], [198, 201, 209, 248, 273], [192, 193, 203, 237, 256, 261, 268], [180, 211, 246, 257, 326, 334], [169, 181, 325, 329, 407], [329], [217, 236, 238], [199, 239], [186, 237, 255, 256], [217, 233, 238], [186, 192, 229, 235, 256], [217, 233, 236, 245], [210, 234], [191, 204, 205, 262, 292, 311], [242, 243, 255, 286, 290], [241, 267, 276, 290], [241, 255], [133, 174, 206, 218, 251, 370, 377], [238, 265, 278, 279], [180, 213, 230, 270, 326], [143, 184, 302], [209, 228, 273, 282, 284], [119, 281, 309, 406, 424], [187, 202, 221, 269, 274, 308], [206, 208, 244, 317, 377, 399], [146, 197, 275, 391, 429], [150, 152, 215, 299, 328, 355], [266, 267, 276, 280, 285], [235, 241, 243, 256, 286, 291], [229, 235, 237, 255, 261, 277, 291], [211, 226, 230, 274, 316, 334], [456], [169, 219, 375, 395], [220, 224, 300], [229, 256, 268, 277, 314, 322, 351], [182, 205, 240, 269, 304, 311, 340], [119, 207, 281, 297, 401], [216, 356], [245, 266, 279], [254, 265, 279, 285, 295, 301], [242, 254, 276, 280], [203, 204, 229, 261, 292, 322], [182, 202, 250, 262, 304, 308, 315], [200, 213, 246, 317, 326, 369, 381], [146, 218, 275, 370, 378], [], [228, 248, 282, 303, 307], [221, 226, 250, 257, 308, 316, 352, 387], [146, 252, 271, 378, 429], [242, 254, 267, 285, 290, 331], [256, 261, 291, 314], [245, 279, 301, 323], [245, 265, 266, 278, 301], [254, 267], [119, 249, 263, 401, 406, 531], [248, 273, 284, 307, 330], [156, 181, 215, 325, 358, 361], [248, 282, 312, 330], [254, 266, 276, 295, 331], [241, 255, 290, 291, 324], [183, 188, 222, 293, 353, 420, 448], [289, 294, 320], [288, 320, 323], [241, 242, 276, 286, 324, 331, 365], [255, 256, 277, 286, 314, 324, 333], [204, 240, 268, 311, 322, 357, 366], [175, 183, 197, 287, 404, 420, 484], [288, 313, 320], [266, 285, 301, 321, 331], [160, 207, 227, 297, 327, 354, 405, 441, 467], [207, 263, 296, 354, 401, 414], [143, 214, 299, 302, 374, 388, 435], [152, 214, 253, 298, 355, 388], [224, 260, 306], [266, 278, 279, 295, 321, 323, 336], [143, 247, 298, 374, 415], [273, 307, 343], [262, 269, 315, 340], [], [224, 300], [273, 282, 303, 330, 343, 346], [250, 269, 274, 315, 352], [249, 424], [216, 318, 356], [240, 262, 292, 340, 366, 380], [284, 330, 337, 347], [294, 320, 335, 338], [261, 277, 291, 333, 351, 373], [269, 304, 308, 340, 352, 386, 394, 433], [257, 274, 334, 387, 400], [200, 208, 251, 270, 381, 399], [136, 216, 310, 422, 470], [335, 344, 359, 362], [288, 289, 294, 313, 323, 338, 339], [295, 301, 331, 336, 348], [261, 268, 292, 351, 357], [278, 289, 301, 320, 336, 339], [286, 290, 291, 333, 350, 365], [181, 231, 283, 361, 407], [230, 246, 270, 334, 360, 369], [188, 227, 296, 353, 405], [215, 253, 355, 358], [231, 232, 375, 407, 493], [282, 284, 307, 312, 346, 347, 383], [276, 285, 290, 295, 321, 348, 349, 364, 365, 368], [223, 342, 345, 408, 421], [291, 314, 324, 350, 373], [230, 257, 316, 326, 360, 400], [313, 319, 338, 344, 359, 363, 367], [301, 321, 323, 339, 348, 371, 372, 393], [312, 347], [313, 320, 335, 339, 363], [320, 323, 336, 338, 363, 371, 390, 397], [262, 304, 311, 315, 380, 386], [136, 212, 342, 422, 442, 494], [212, 332, 341, 421, 442], [303, 307, 346], [319, 335, 359], [219, 223, 332, 408, 460], [307, 330, 343, 382, 383], [312, 330, 337, 383, 384], [321, 331, 336, 349, 372], [331, 348, 364, 372], [324, 333, 365, 373, 398, 419], [261, 314, 322, 357, 373, 413, 430], [274, 308, 315, 387, 433, 455], [188, 287, 327, 405, 448, 550], [296, 297, 414, 441, 527, 597], [253, 299, 328, 358, 388, 489, 490], [216, 264, 310], [292, 322, 351, 366, 413, 451, 452], [215, 283, 328, 355, 361, 490, 491], [319, 335, 344, 362, 367, 379], [326, 334, 369, 400, 434, 445], [215, 283, 325, 358, 407, 491, 492], [319, 359, 379, 389], [335, 338, 339, 367, 385, 397, 417], [331, 349, 368, 372, 393, 403, 427, 431], [290, 324, 331, 350, 368, 398, 412, 432], [292, 311, 357, 380, 452, 458], [335, 359, 363, 379, 385, 410, 411], [331, 364, 365, 403, 412], [270, 326, 360, 381, 428, 434], [218, 244, 271, 377, 378, 474], [336, 339, 390, 393, 418], [336, 348, 349, 364, 393], [314, 333, 350, 351, 419, 430], [298, 302, 435], [259, 329, 395, 475, 493], [449, 499], [244, 251, 370, 399, 447, 474], [271, 275, 370, 429, 466, 474, 481], [359, 362, 367, 389, 402, 410, 416], [311, 340, 366, 386, 458, 459], [270, 317, 369, 399, 428, 446], [346, 383], [330, 346, 347, 382, 384], [347, 383], [363, 367, 411, 417], [315, 340, 380, 394, 459], [274, 316, 352, 400, 455, 465], [298, 299, 355, 435, 487, 488, 489], [362, 379, 392, 402], [339, 371, 397, 418, 437, 440], [197, 252, 404, 429], [389, 396, 402, 409, 423, 426], [336, 364, 371, 372, 418, 427], [315, 386, 433, 459, 480, 507], [219, 259, 375, 436, 475, 508], [392, 409, 425], [339, 363, 390, 417, 437, 440], [350, 365, 419, 432], [251, 317, 377, 381, 446, 447, 483], [316, 334, 360, 387, 445, 465, 545], [263, 281, 297, 414, 524, 531], [379, 389, 392, 416, 423], [364, 368, 412, 431], [197, 293, 391, 429, 484, 585, 611, 638, 679], [296, 327, 353, 467, 550, 603], [249, 281, 424, 531], [231, 325, 329, 361, 492, 493], [332, 345, 421, 460, 505, 541], [392, 396, 425, 426, 457], [367, 379, 411, 416, 438, 439], [367, 385, 410, 417, 439], [365, 368, 403, 431, 432, 496], [351, 357, 430, 451], [297, 354, 401, 524, 527], [302], [379, 402, 410, 423, 438, 450], [363, 385, 397, 411, 439, 440, 454], [371, 390, 393, 427, 440, 461], [350, 373, 398, 430, 432, 451, 472, 477], [287, 293, 448, 484, 515, 687, 693], [332, 342, 408, 442, 505], [136, 318, 341, 470, 494, 542], [392, 402, 416, 426, 450], [249, 309, 406, 531, 572, 591], [396, 409, 453, 457, 462], [392, 409, 423, 450, 457], [364, 393, 418, 431, 444, 461, 464], [369, 381, 434, 446, 522, 523], [252, 275, 378, 391, 404, 466], [351, 373, 413, 419, 451], [364, 403, 412, 427, 444, 476, 496, 506], [365, 398, 412, 419, 472, 496, 497], [315, 352, 394, 455, 480], [360, 369, 428, 445, 522], [298, 374, 388, 487], [219, 395, 460, 508], [390, 397, 440], [410, 416, 439, 443, 450, 469], [410, 411, 417, 438, 443, 454, 473], [390, 397, 417, 418, 437, 454, 461, 463], [296, 354, 467, 597, 603, 606, 688], [341, 342, 421, 494, 505, 532], [438, 439, 469, 473], [427, 431, 464, 476], [360, 400, 434, 522, 545, 561, 590], [381, 399, 428, 483, 523], [377, 399, 474, 483, 511], [287, 353, 420, 515, 550], [376, 499], [416, 423, 426, 438, 457, 469, 471], [357, 413, 419, 430, 452, 477, 486, 510], [357, 366, 451, 458, 510, 514], [425, 462, 468, 501], [417, 439, 440, 463, 473, 479, 482], [352, 387, 433, 465, 480, 504], [258], [409, 425, 426, 450, 462, 471], [366, 380, 452, 459, 514, 539], [380, 386, 394, 458, 507, 530, 539], [345, 408, 436, 541], [418, 427, 440, 463, 464, 476, 485, 495, 503], [425, 453, 457, 471, 501, 517, 534], [440, 454, 461, 479, 485], [427, 444, 461, 476], [387, 400, 455, 504, 545, 556, 576], [378, 429, 481, 611, 664], [296, 405, 441, 603], [453, 500, 501, 516], [438, 443, 450, 471, 473, 502, 535, 544], [318, 422, 542], [450, 457, 462, 469, 517, 535], [419, 432, 477, 497, 538], [439, 443, 454, 469, 482, 502], [370, 377, 378, 447, 481, 511, 602, 610], [375, 395, 493, 508, 562, 577], [431, 444, 461, 464, 503, 506, 512, 537], [419, 451, 472, 486, 513, 538], [498, 533, 543], [454, 463, 482, 485, 518], [394, 433, 455, 504, 507, 526], [378, 466, 474, 602, 664, 703], [454, 473, 479, 502, 518, 536], [399, 446, 447, 523, 656, 663], [293, 404, 420, 585, 643, 687], [461, 463, 479, 495, 518, 519], [451, 477, 510, 513, 529, 549, 571, 616, 652, 662], [388, 435, 488, 564], [388, 487, 489, 546, 564, 618, 627], [355, 388, 488, 490, 546], [355, 358, 489, 491, 546, 573, 586], [358, 361, 490, 492, 540, 573], [361, 407, 491, 493, 540, 551, 580], [329, 375, 407, 475, 492, 551, 577], [341, 422, 442, 532, 542, 592, 599], [461, 485, 503, 519], [412, 431, 432, 497, 506, 521], [432, 472, 496, 521, 538, 548], [478, 543, 566, 581], [376, 449], [468, 509, 516, 528, 552, 554], [453, 462, 468, 516, 534], [469, 473, 482, 536, 544], [461, 476, 495, 512, 519, 520, 563], [455, 465, 480, 526, 556], [408, 421, 442, 532, 541, 565], [431, 476, 496, 521, 537, 547], [394, 459, 480, 526, 530, 575], [395, 436, 475, 557, 562], [500, 528], [451, 452, 486, 514, 529], [447, 474, 610], [476, 503, 520, 537, 563], [477, 486, 538, 549, 553], [452, 458, 510, 529, 539, 617], [420, 448, 550, 644, 693, 792], [468, 500, 501, 534, 552], [462, 471, 534, 535, 555, 558, 567], [479, 482, 485, 519, 536, 559, 568], [485, 495, 503, 518, 559, 563], [503, 512, 563], [496, 497, 506, 547, 548, 560], [428, 434, 445, 523, 561], [428, 446, 483, 522, 642, 656], [401, 414, 527, 531, 579, 633], [564], [480, 504, 507, 556, 575], [354, 414, 524, 579, 597], [500, 509, 554], [486, 510, 514, 571, 617, 652, 666], [459, 507, 539, 575], [281, 401, 406, 424, 524, 572, 633, 647, 680], [442, 494, 505, 565, 592], [478, 543, 582], [462, 501, 516, 517, 552, 555], [469, 471, 517, 544, 558, 584], [482, 502, 518, 544, 568], [476, 506, 512, 547, 563, 578, 583], [472, 477, 497, 513, 548, 553, 570], [458, 459, 514, 530, 617], [491, 492, 573, 580, 604], [408, 460, 505, 565, 574, 619], [422, 470, 494, 581, 599, 620], [478, 498, 533, 566, 582, 612], [469, 502, 535, 536, 568, 584, 594, 607, 613], [400, 445, 465, 576, 590, 626], [488, 489, 490, 586, 627], [506, 521, 537, 560, 583], [497, 521, 538, 560, 570, 600, 609], [486, 513, 553, 616], [353, 405, 448, 515, 603, 644], [492, 493, 577, 580, 634], [500, 516, 534, 554, 555, 593], [513, 538, 549, 570, 616, 629], [500, 528, 552, 593], [517, 534, 552, 567, 593, 621], [465, 504, 526, 576, 601], [508, 562, 598, 670], [517, 535, 567, 584], [518, 519, 568, 569, 595], [521, 547, 548, 583, 600], [445, 522, 590, 692], [475, 508, 557, 577, 670], [503, 512, 519, 520, 537, 569, 578, 589, 596], [487, 488, 525, 618], [505, 532, 541, 592, 619, 650, 665], [498, 543, 581, 612, 623, 624, 635, 645], [517, 555, 558, 584, 621, 625], [518, 536, 544, 559, 594, 595, 614], [559, 563, 589, 595], [538, 548, 553, 609, 629, 641], [486, 529, 652], [424, 531, 591, 680], [490, 491, 540, 586, 604, 648, 689, 714], [541, 598, 628, 671], [507, 526, 530, 632], [465, 545, 556, 601, 626, 654], [475, 493, 551, 562, 634, 670, 709], [537, 563, 583, 596, 605], [524, 527, 597, 633, 639], [492, 540, 551, 604, 630, 634, 705], [498, 542, 566, 620, 623], [533, 543, 612, 631], [537, 547, 560, 578, 600, 605, 615], [535, 544, 558, 567, 607, 625], [404, 484, 643, 679], [490, 546, 573, 627, 648, 712], [], [], [563, 569, 595, 596, 622], [445, 545, 561, 626, 655, 692], [424, 572, 680], [494, 532, 565, 599, 650], [552, 554, 555, 621, 658, 673], [544, 568, 595, 613, 614, 651, 696, 697], [559, 568, 569, 589, 594, 614, 622], [563, 578, 589, 605, 608, 622, 636], [354, 441, 527, 579, 606, 639, 732, 738, 748, 810, 811], [557, 574, 628, 670, 700], [494, 542, 592, 620, 650], [548, 560, 583, 609, 615, 637, 661], [556, 576, 653, 654, 698], [474, 481, 610, 703, 743], [405, 441, 467, 550, 644, 688, 744, 814], [540, 573, 580, 630, 713, 714], [578, 583, 596, 608, 615], [441, 597, 688, 738], [544, 584, 613, 625, 651, 676], [596, 605, 636], [548, 570, 600, 637, 641], [474, 511, 602, 734, 743], [404, 466, 638, 664], [543, 566, 582, 645], [544, 594, 607, 651], [568, 594, 595, 622, 659, 696, 697], [82, 583, 600, 605, 661], [486, 549, 553, 629, 662, 691], [514, 529, 539, 666], [488, 564, 627, 668, 669], [541, 565, 665], [542, 581, 599, 623, 650, 682], [555, 567, 593, 625, 658], [589, 595, 596, 614, 636, 659, 660], [566, 581, 620, 635, 672, 683], [566, 635, 645, 706], [567, 584, 607, 621, 658, 676, 699], [545, 576, 590, 654, 655], [488, 546, 586, 618, 669, 712], [574, 598, 671, 700], [553, 570, 616, 641, 686, 691], [580, 604, 705, 713], [582, 640, 695], [575, 674, 678], [524, 531, 579, 639, 647, 704], [551, 577, 580, 705, 709], [566, 623, 624, 672, 706], [596, 608, 622, 660, 677], [600, 609, 641, 661, 685], [404, 611, 664, 679, 770, 780, 786], [579, 597, 633, 704, 732], [631, 695], [570, 609, 629, 637, 685, 686], [523, 656], [484, 585, 679, 687, 780], [515, 550, 603, 792, 814], [566, 612, 624], [677], [531, 633, 680, 704, 739], [573, 586, 689, 712, 782, 804, 812], [657, 749], [565, 592, 599, 620, 665, 682, 694], [594, 607, 613, 676, 696, 707, 708, 711], [486, 529, 571, 662, 666, 728, 741], [601, 674, 698], [576, 601, 626, 655, 698, 756, 769], [590, 626, 654, 692, 742, 756, 769], [483, 523, 642, 663, 808], [649, 749, 771], [593, 621, 625, 673, 699, 717, 720], [614, 622, 660, 684, 690, 697], [622, 636, 659, 677, 684], [82, 600, 615, 637, 685, 722], [486, 616, 652, 691, 727, 741], [483, 656, 734, 795, 808], [466, 481, 611, 638, 703, 770, 779, 791], [565, 619, 650, 694, 701, 710], [529, 617, 652, 728], [724, 766], [618, 669, 745], [618, 627, 668, 712, 745], [557, 562, 577, 598, 700, 709, 729], [574, 628, 700, 798], [623, 635, 683, 706, 735, 736], [593, 658, 719, 720], [632, 653, 678], [710, 758], [607, 625, 651, 699, 707, 711, 733], [636, 646, 660, 684, 702], [632, 674], [404, 585, 638, 643, 780], [531, 572, 591, 647, 739, 781], [], [620, 650, 683, 694, 715, 716, 730, 751], [623, 672, 682, 730, 735], [659, 660, 677, 690, 702, 721, 737], [637, 641, 661, 686, 722, 726], [629, 641, 685, 691, 723, 726], [420, 484, 643, 693, 780, 851, 877], [441, 603, 606, 738, 744, 843, 878], [573, 648, 714, 782], [659, 684, 697], [616, 629, 662, 686, 723, 727, 731], [561, 590, 655, 718, 742, 757], [420, 515, 687, 792, 803, 877], [650, 665, 682, 701], [631, 640], [594, 614, 651, 697, 707, 708], [594, 614, 659, 690, 696, 708], [601, 653, 654, 756], [625, 658, 676, 717, 733], [598, 628, 670, 671, 729, 788, 798], [665, 694, 710, 758], [677, 684, 721, 725], [481, 602, 664, 743, 779, 831], [633, 639, 647, 732, 739, 765], [580, 630, 634, 709, 713, 787, 796, 858], [624, 635, 672, 736], [651, 676, 696, 708, 711], [651, 696, 697, 707], [577, 634, 670, 705, 729, 796, 797, 815, 880], [665, 675, 701, 758], [651, 676, 707], [586, 627, 648, 669, 745, 812, 824], [604, 630, 705, 714, 787], [573, 604, 689, 713, 782, 787, 879, 893], [682, 716, 750, 802, 805], [682, 715, 751, 802], [658, 699, 720, 733, 747, 776, 790], [692, 757, 778], [673, 720, 747, 753, 762], [658, 673, 717, 719, 747], [684, 702, 725, 737, 763, 764], [661, 685, 726, 760], [686, 691, 726, 731, 755, 768], [667, 766], [702, 721, 764, 785], [685, 686, 722, 723, 754, 755, 760], [662, 691, 731, 741, 773], [652, 666, 741, 774], [670, 700, 709, 788, 797], [682, 683, 735, 751], [691, 723, 727, 768, 773, 813], [597, 639, 704, 748, 765], [676, 699, 717, 776], [610, 663, 743, 775, 795], [672, 683, 730, 736, 751, 789, 806, 819, 820, 827], [672, 706, 735, 789], [684, 721, 763], [597, 606, 688, 810, 844, 878], [647, 680, 704, 765, 781, 832], [746, 772, 807, 828], [652, 662, 727, 728, 773, 774, 800], [655, 692, 757, 769, 777, 794], [602, 610, 703, 734, 775, 831, 854], [603, 688, 814, 843, 864], [668, 669, 712, 823, 824], [740, 752, 772], [717, 719, 720, 762, 783, 790], [597, 732, 765, 811, 822, 888], [649, 657, 771, 816, 817, 825], [715, 761, 805], [682, 716, 730, 735, 802, 819, 833], [746, 753, 767, 772], [719, 752, 762, 767, 793], [726, 755, 760], [723, 726, 754, 768, 799], [654, 655, 698, 769], [692, 718, 742, 778, 794, 801, 841, 842], [675, 701, 710, 759, 771], [758, 761, 805, 826, 882, 883], [722, 726, 754], [750, 759, 805], [719, 747, 753, 783, 793, 821], [721, 737, 764], [721, 725, 763, 785, 846], [704, 732, 739, 748, 822, 832, 848], [667, 724], [752, 753, 772, 793, 838], [723, 731, 755, 799, 813], [654, 655, 742, 756, 777, 849], [638, 664, 786, 791], [657, 749, 758, 817], [740, 746, 752, 767, 828, 838, 856], [727, 731, 741, 800, 813, 852], [728, 741, 800, 829, 835], [734, 743, 795, 837, 854], [717, 733, 790], [742, 769, 794, 849, 862], [718, 757, 842], [664, 703, 791, 809, 831], [638, 643, 679, 687, 786, 850, 851, 874, 903, 925], [680, 739, 832], [648, 689, 714, 804, 893], [747, 762, 790, 821, 839], [], [725, 764, 834, 846], [638, 770, 780, 791, 855, 892, 903], [705, 713, 714, 858, 879], [700, 729, 797, 798, 845, 880, 901], [735, 736, 806], [717, 747, 776, 783, 839], [664, 770, 779, 786, 809, 855], [515, 644, 693, 803, 814, 904], [753, 762, 767, 821, 838, 860, 869], [742, 757, 777, 801, 841, 862, 863], [663, 734, 775, 808, 837], [705, 709, 815, 858, 919], [709, 729, 788, 880], [671, 700, 788, 816, 845, 865, 881], [755, 768, 813, 872, 917], [741, 773, 774, 829, 840, 852], [757, 794, 841], [715, 716, 751, 805, 818, 833, 859], [693, 792, 877, 904, 954], [648, 782, 812, 893, 955], [715, 750, 759, 761, 802, 818, 866, 883, 884, 889], [735, 789, 820], [740, 828, 867], [656, 663, 795, 837, 885, 924, 945, 965], [779, 791, 831, 855, 886, 895], [597, 738, 811, 844, 887], [597, 748, 810, 887], [648, 712, 804, 824, 926, 955], [731, 768, 773, 799, 852, 872], [603, 644, 744, 792, 864, 904, 942, 966, 1027], [709, 796, 880, 919], [749, 798, 825, 865, 920], [749, 771, 825, 826, 902, 906], [802, 805, 859, 866], [735, 751, 827, 833], [735, 806, 827], [762, 783, 793, 839, 869, 897], [748, 765, 848, 888], [745, 824, 926, 938], [712, 745, 812, 823, 926], [749, 816, 817, 906, 920], [759, 817, 882, 902], [735, 819, 820, 833], [740, 772, 807, 856, 867, 868], [774, 800, 835, 840], [836, 853, 890], [703, 743, 779, 809, 854, 895], [739, 765, 781, 848, 896], [751, 802, 819, 827, 859], [785, 846, 871, 876], [774, 829, 873], [830, 847, 890, 894, 900], [775, 795, 808, 854, 924], [767, 772, 793, 856, 860], [783, 790, 821, 897], [800, 829, 852], [757, 794, 801, 842, 863, 907], [757, 778, 841, 907, 934], [688, 744, 864, 878, 936], [738, 810, 878, 887, 932], [788, 798, 881, 901], [764, 785, 834, 871], [836, 873, 899, 900], [765, 822, 832, 896, 908], [769, 777, 861, 862, 891], [780, 851, 874, 929], [687, 780, 850, 877, 929], [773, 800, 813, 840, 872, 910], [830, 861, 890, 911], [743, 775, 831, 837, 895, 924, 935], [786, 791, 809, 886, 892], [772, 828, 838, 860, 868, 909], [], [705, 787, 796, 879, 919, 974, 992, 1009], [802, 818, 833, 866, 912], [793, 838, 856, 869, 909, 916], [849, 853, 891, 911], [777, 794, 849, 863, 891, 923], [794, 841, 862, 907, 923, 931, 960], [744, 814, 843, 936, 942, 985, 1001], [798, 816, 881, 920, 972], [805, 818, 859, 884, 912, 921, 927], [807, 828, 868, 915], [828, 856, 867, 909, 915, 939], [793, 821, 860, 897, 916, 944, 958, 969], [], [834, 846, 876, 913], [799, 813, 852, 910, 917], [835, 847, 899], [780, 850, 925, 929], [905, 991, 1046, 1047], [834, 871], [687, 693, 803, 851, 929, 954, 983, 984], [688, 738, 843, 844, 932, 936], [714, 787, 858, 893, 992, 1017], [709, 788, 797, 815, 901, 919, 971, 974, 975, 987], [798, 845, 865, 901, 971, 972], [759, 826, 883, 902, 914, 956, 968], [759, 805, 882, 889, 914, 930], [805, 866, 889, 921, 930], [808, 945, 999], [809, 855, 892, 895, 935, 941], [810, 811, 844, 932, 961], [748, 822, 937], [805, 883, 884, 930], [830, 836, 853, 894, 911], [849, 861, 862, 911, 923, 940, 953], [786, 855, 886, 903, 941, 946], [714, 782, 804, 879, 955, 1017, 1022, 1063], [836, 890, 900, 911, 951], [809, 831, 854, 886, 935], [832, 848, 908, 967, 986, 990], [821, 839, 869, 958], [899, 950, 959], [847, 873, 898, 900, 922, 959], [836, 847, 894, 899, 922, 951, 964], [788, 845, 880, 881, 971], [817, 826, 882, 906, 968], [780, 786, 892, 925, 946, 977], [792, 803, 814, 954, 966, 1007], [875, 991], [817, 825, 902, 920, 968, 981], [841, 842, 863, 934, 960], [848, 896, 967], [856, 860, 868, 916, 939, 948], [852, 872, 917, 963], [853, 861, 890, 891, 894, 940, 951, 952, 970], [859, 866, 927], [871], [882, 883, 930, 943, 956], [867, 868, 939], [860, 869, 909, 944, 948], [799, 872, 910, 963], [], [796, 815, 858, 880, 974], [816, 825, 865, 906, 972, 981], [866, 884, 927, 930, 947], [899, 900, 959, 964, 973], [862, 863, 891, 931, 933, 953, 998], [808, 837, 854, 935, 965, 989, 1031, 1032], [780, 874, 903, 929, 977, 984, 1035, 1122], [812, 823, 824, 938, 955, 978, 1012], [866, 912, 921], [], [850, 851, 874, 877, 925, 983, 1035], [883, 884, 889, 914, 921, 943, 947, 957, 962], [863, 923, 933, 960], [844, 878, 887, 936, 961, 1021, 1028, 1038], [923, 931, 960, 998, 1030, 1037], [842, 907, 960, 1005, 1019], [854, 886, 895, 924, 941, 1032], [843, 864, 878, 932, 985, 1021], [888], [823, 926, 978], [868, 909, 915, 948, 1003, 1029], [891, 911, 952, 953, 997], [886, 892, 935, 946, 980, 1020, 1032], [814, 864, 1001, 1027, 1033], [914, 930, 956, 957, 1018], [869, 916, 948, 969, 976, 982], [808, 885, 965, 999, 1000], [892, 903, 941, 977, 980], [921, 930, 962], [909, 916, 939, 944, 976, 1003], [], [898, 959, 1011], [894, 900, 911, 964, 970, 994, 1015], [911, 940, 970, 997], [891, 923, 940, 997, 998], [803, 877, 904, 984, 1006, 1007], [804, 812, 893, 926, 1012, 1063, 1084, 1106], [882, 914, 943, 968, 1018, 1034], [930, 943, 962, 1002, 1018], [869, 897, 969], [898, 899, 922, 950, 973, 1011], [863, 907, 931, 933, 934, 1019, 1030], [887, 932, 995, 1028], [930, 947, 957, 1002, 1014], [910, 917], [900, 922, 951, 973, 994, 1025], [808, 924, 945, 989, 1000, 1026], [814, 904, 1007, 1027], [896, 908, 990, 1008], [882, 902, 906, 956, 981, 1013, 1034], [869, 944, 958, 982, 1010], [911, 951, 952, 997, 1015, 1049, 1055, 1067], [880, 881, 901, 972, 987, 1040, 1079, 1091], [865, 881, 920, 971, 981, 1040], [922, 959, 964, 1011, 1025], [858, 880, 919, 975, 1009, 1052], [880, 974, 987, 1052, 1059, 1086], [944, 948, 982, 1003, 1023], [903, 925, 946, 980, 1050, 1122], [926, 938, 1012, 1051], [], [941, 946, 977, 1020, 1050, 1083], [906, 920, 968, 972, 1013, 1040, 1073], [944, 969, 976, 1010, 1023], [877, 929, 984, 1035], [877, 925, 954, 983, 1006, 1035, 1122, 1146, 1166, 1179], [864, 936, 1001, 1021, 1056], [896, 990, 1058], [880, 971, 975, 1079, 1086], [], [924, 965, 1026, 1031, 1121], [896, 967, 986, 1008, 1057, 1058], [875, 905, 1045, 1046], [858, 879, 1009, 1017, 1048, 1143], [1024], [951, 964, 1015, 1025, 1043], [961, 1028, 1044], [1004], [940, 952, 953, 970, 998, 1049], [923, 933, 953, 997, 1037, 1049], [885, 945, 1000, 1062, 1068], [945, 965, 999, 1026, 1062, 1082], [864, 942, 985, 1033, 1056, 1123], [957, 962, 1014, 1018, 1036, 1075, 1076], [939, 948, 976, 1023, 1029, 1041], [996], [934, 1019, 1068, 1081], [954, 984, 1007, 1130, 1146, 1174, 1197, 1202], [904, 954, 966, 1006, 1027, 1130], [967, 990, 1057], [858, 974, 992, 1052, 1143, 1172, 1186, 1211], [969, 982, 1023], [950, 959, 973, 1025], [926, 955, 978, 1051, 1084], [968, 981, 1034, 1064, 1073], [962, 1002, 1036], [951, 970, 994, 1043, 1055], [1044, 1071], [879, 893, 992, 1022, 1048, 1085, 1096], [943, 956, 957, 1002, 1034, 1074, 1075], [934, 960, 1005, 1030, 1081, 1092], [941, 980, 1032, 1083, 1114], [932, 936, 985, 1038, 1056, 1069, 1147], [893, 1017, 1063, 1095, 1096], [976, 982, 1003, 1010, 1041, 1077], [993], [964, 973, 994, 1011, 1043], [965, 989, 1000, 1082, 1121, 1180], [814, 942, 966, 1007, 1033, 1130, 1131], [932, 961, 995, 1038, 1044, 1070], [939, 1003], [933, 960, 1019, 1037, 1092, 1094], [924, 989, 1032, 1117, 1121], [924, 935, 941, 1020, 1031, 1114, 1117], [942, 1001, 1027, 1123, 1131], [956, 968, 1013, 1018, 1064, 1074], [925, 929, 983, 984], [1002, 1014, 1076], [933, 998, 1030, 1049, 1061, 1094], [932, 1021, 1028, 1069, 1070, 1148], [1045, 1072, 1090], [971, 972, 981, 1073, 1091], [1003, 1023, 1077, 1097, 1101], [1053, 1054, 1088], [994, 1015, 1025], [995, 1016, 1028, 1070, 1071, 1150], [991, 1039, 1046, 1072, 1089], [875, 991, 1045, 1047, 1089], [875, 1046, 1089], [992, 1017, 1085, 1143, 1162], [970, 997, 998, 1037, 1061, 1067, 1113, 1159], [977, 980, 1083, 1122, 1129, 1155, 1160], [978, 1012, 1084, 1126], [974, 975, 1009, 1059, 1172], [1042, 1060, 1066, 1088], [1042, 1088, 1103], [970, 1015, 1067, 1100], [985, 1001, 1021, 1123, 1147], [990, 1008, 1058, 1078, 1115], [986, 990, 1057, 1078], [975, 1052, 1086, 1144, 1172, 1194], [1053, 1065, 1066, 1093, 1099], [1037, 1049, 1094, 1139, 1159], [999, 1000, 1068, 1082, 1105, 1178], [893, 955, 1022, 1095, 1106, 1142, 1161], [1013, 1034, 1073, 1074, 1107, 1134, 1135, 1169, 1176, 1177], [1060, 1080, 1093, 1098], [1053, 1060, 1088, 1099, 1128, 1165], [970, 1049, 1055, 1100, 1113, 1120], [999, 1005, 1062, 1081, 1104, 1105], [1021, 1038, 1147, 1148], [1028, 1038, 1044, 1148, 1149, 1150, 1167], [1016, 1044], [1039, 1045, 1089, 1090, 1111, 1125], [981, 1013, 1040, 1064, 1091, 1107], [1018, 1034, 1064, 1075, 1135, 1136], [1002, 1018, 1074, 1076, 1087, 1108, 1136], [1002, 1036, 1075, 1087, 1109], [1023, 1041, 1097], [1057, 1058, 1115], [971, 987, 1086, 1091, 1144, 1151, 1163], [1065, 1098, 1102], [1005, 1019, 1068, 1092, 1104, 1140, 1154], [1000, 1026, 1062, 1178, 1180], [980, 1020, 1050, 1114, 1129, 1181], [955, 1012, 1051, 1106, 1126], [1017, 1048, 1096, 1162, 1185], [975, 987, 1059, 1079, 1144], [1075, 1076, 1108, 1109, 1137], [1042, 1053, 1054, 1066, 1103, 1153, 1165], [1045, 1046, 1047, 1072], [1039, 1072, 1110, 1111], [971, 1040, 1073, 1079, 1107, 1134, 1151, 1152], [1019, 1030, 1081, 1094, 1140, 1145], [1060, 1065, 1098, 1099, 1164], [1030, 1037, 1061, 1092, 1139, 1145, 1191], [1022, 1063, 1096, 1142], [1017, 1022, 1085, 1095, 1142, 1185], [1041, 1077, 1101, 1119, 1138, 1157, 1188, 1204], [1065, 1080, 1093, 1102, 1127, 1164, 1170], [1060, 1066, 1093, 1128, 1164], [1055, 1067, 1120, 1173], [1041, 1097, 1157], [1080, 1098, 1127], [1054, 1088, 1153], [1068, 1081, 1105, 1154], [1062, 1068, 1104, 1154, 1178, 1207], [955, 1063, 1084, 1126, 1161, 1184], [1064, 1073, 1091, 1134], [1075, 1087, 1136, 1137, 1156], [1076, 1087, 1137], [1090, 1111, 1118, 1132, 1133], [1072, 1090, 1110, 1125, 1133, 1168], [], [1049, 1067, 1120, 1158, 1159, 1190], [1020, 1032, 1083, 1117, 1171, 1181], [1057, 1078], [], [1031, 1032, 1114, 1121, 1171, 1222], [1110, 1124, 1132, 1141], [1097, 1138], [1067, 1100, 1113, 1158, 1173, 1189], [989, 1026, 1031, 1117, 1180, 1222], [925, 977, 984, 1050, 1160, 1179, 1227, 1254], [1001, 1033, 1056, 1131, 1147, 1182, 1203], [1118, 1141], [1072, 1111, 1168], [1051, 1084, 1106, 1184], [1098, 1102, 1138, 1170], [1066, 1099, 1164, 1165, 1205], [1050, 1083, 1155, 1181, 1201, 1271], [1006, 1007, 1027, 1131, 1182, 1197, 1242], [1027, 1033, 1123, 1130, 1182], [1110, 1118, 1133, 1141], [1110, 1111, 1132, 1168], [1064, 1091, 1107, 1152, 1176, 1187], [1064, 1074, 1136, 1169, 1195, 1218, 1223], [1074, 1075, 1108, 1135, 1156, 1195], [1087, 1108, 1109, 1156], [1097, 1119, 1127, 1170, 1204], [1061, 1094, 1159, 1191, 1220], [1081, 1092, 1145, 1154, 1217], [1118, 1124, 1132], [1063, 1095, 1096, 1161, 1185, 1210], [992, 1009, 1048, 1162, 1186, 1267], [1059, 1079, 1086, 1163, 1194, 1228], [1092, 1094, 1140, 1191, 1217, 1221, 1239], [984, 1006, 1166, 1174, 1196, 1237, 1255], [1021, 1056, 1069, 1123, 1148, 1203, 1208], [1038, 1069, 1070, 1147, 1167, 1208, 1214], [1070, 1150, 1167, 1183], [1044, 1070, 1149, 1183, 1215], [1079, 1091, 1152, 1163, 1212, 1229], [1091, 1134, 1151, 1187, 1212], [1088, 1103, 1165, 1206], [1081, 1104, 1105, 1140, 1207, 1217], [1050, 1129, 1160, 1201, 1236], [1108, 1136, 1137, 1195], [1097, 1101, 1188, 1199], [1113, 1120, 1189, 1190, 1226], [1049, 1061, 1113, 1139, 1190, 1220], [1050, 1122, 1155, 1227, 1236, 1260], [1063, 1106, 1142, 1184, 1210, 1240, 1245], [1048, 1085, 1143, 1185, 1267], [1079, 1144, 1151, 1228, 1229], [1093, 1098, 1099, 1128, 1170, 1205, 1231, 1256], [1066, 1088, 1128, 1153, 1205, 1206, 1225, 1265, 1280], [984, 1146, 1179, 1237, 1272], [1070, 1148, 1149, 1183, 1192, 1214], [1111, 1125, 1133], [1064, 1135, 1177, 1213, 1223], [1098, 1127, 1138, 1164, 1204, 1247, 1256], [1114, 1117, 1181, 1222, 1259, 1264], [1009, 1052, 1059, 1194, 1211, 1241], [1100, 1120, 1189, 1200], [1006, 1146, 1196, 1202, 1276], [1193], [1064, 1134, 1177, 1187, 1216, 1252, 1309, 1310], [1064, 1169, 1176, 1213, 1252], [1062, 1082, 1105, 1180, 1207, 1235], [984, 1122, 1166, 1254, 1272], [1026, 1082, 1121, 1178, 1222, 1235, 1249, 1270], [1083, 1114, 1129, 1171, 1264, 1271, 1281], [1123, 1130, 1131, 1203, 1242], [1149, 1150, 1167, 1192, 1215, 1243, 1244, 1261], [1106, 1126, 1161, 1240], [1085, 1096, 1142, 1162, 1210, 1267, 1273], [1009, 1143, 1211, 1241, 1267, 1321], [1134, 1152, 1176, 1212, 1216, 1284, 1285], [1097, 1157, 1199, 1204, 1224, 1230], [1120, 1158, 1173, 1200, 1226], [1113, 1158, 1159, 1220, 1226, 1269], [1094, 1139, 1145, 1220, 1239], [1167, 1183, 1214, 1261], [1175], [1059, 1144, 1172, 1228, 1241, 1262], [1135, 1136, 1156, 1218], [1146, 1174, 1255, 1276, 1296], [1006, 1130, 1202, 1242, 1277], [1209], [1157, 1188, 1219, 1224], [1173, 1189, 1226, 1234], [1129, 1155, 1236, 1266, 1271, 1295], [1006, 1174, 1197, 1276, 1277], [1123, 1147, 1182, 1208, 1242, 1250, 1288, 1292, 1297], [1097, 1138, 1170, 1188, 1230, 1247], [1128, 1164, 1165, 1231, 1265], [1153, 1165, 1225], [1105, 1154, 1178, 1217, 1235, 1253, 1287], [1147, 1148, 1203, 1214, 1250], [1198, 1251], [1142, 1161, 1185, 1245, 1273], [1009, 1172, 1186, 1241], [1151, 1152, 1187, 1229, 1284, 1285], [1169, 1177, 1223, 1252, 1278], [1148, 1167, 1192, 1208, 1250, 1261], [1150, 1183, 1243, 1244], [1176, 1187, 1285, 1309], [1140, 1145, 1154, 1207, 1221, 1253, 1275], [1135, 1195, 1223], [1199, 1224, 1246, 1268], [1139, 1159, 1190, 1191, 1239, 1269, 1274, 1339], [1145, 1217, 1239, 1275, 1294], [1117, 1121, 1171, 1180, 1249, 1258, 1259], [1135, 1169, 1213, 1218, 1278], [1188, 1199, 1219, 1230, 1246, 1279], [1165, 1206, 1232, 1280, 1315], [1158, 1189, 1190, 1200, 1234, 1257, 1269, 1291, 1293], [1122, 1160, 1254, 1260, 1282], [1144, 1163, 1194, 1229, 1262, 1305, 1308, 1311], [1151, 1163, 1212, 1228, 1284, 1308], [1188, 1204, 1224, 1247, 1279], [1164, 1205, 1256, 1265, 1334], [1225, 1248, 1315], [1238, 1263, 1342], [1200, 1226, 1257, 1302, 1306], [1178, 1180, 1207, 1270, 1287], [1155, 1160, 1201, 1260, 1266], [1146, 1166, 1255, 1272, 1363, 1395], [1233, 1300, 1342], [1145, 1191, 1220, 1221, 1274, 1294], [1161, 1184, 1245, 1319], [1172, 1186, 1194, 1211, 1262, 1321, 1326, 1392], [1130, 1182, 1197, 1203, 1277, 1288], [1183, 1215, 1244, 1261, 1298], [1183, 1215, 1243, 1283], [1161, 1210, 1240, 1273, 1320], [1219, 1224, 1268, 1279, 1299], [1170, 1204, 1230, 1256, 1279, 1341, 1353], [1232, 1300, 1315], [1180, 1222, 1258, 1270, 1344, 1351], [1203, 1208, 1214, 1261, 1297, 1304, 1335, 1347], [1209], [1176, 1177, 1213, 1278, 1310, 1322, 1323], [1207, 1217, 1275, 1287, 1324], [1122, 1179, 1227, 1272, 1282, 1318, 1333, 1357], [1146, 1196, 1237, 1296, 1363], [1164, 1170, 1231, 1247, 1334, 1353, 1433], [1226, 1234, 1302], [1222, 1249, 1259, 1344, 1354], [1171, 1222, 1258, 1264, 1354], [1160, 1227, 1236, 1266, 1282, 1303], [1183, 1192, 1214, 1243, 1250, 1298, 1304], [1194, 1228, 1241, 1305, 1326], [1233, 1286, 1342], [1171, 1181, 1259, 1281, 1352, 1354], [1165, 1205, 1231, 1280, 1334], [1201, 1236, 1260, 1295, 1303, 1313], [1143, 1162, 1185, 1186, 1273, 1321, 1348, 1349], [1219, 1246, 1299, 1314], [1190, 1220, 1226, 1291, 1329, 1339], [1180, 1235, 1249, 1287, 1330, 1351], [1129, 1181, 1201, 1281, 1295, 1331, 1345, 1378], [1166, 1179, 1237, 1254, 1357, 1388, 1395, 1398, 1399], [1185, 1210, 1245, 1267, 1320, 1348], [1220, 1239, 1294, 1339, 1343, 1361, 1368], [1217, 1221, 1253, 1294, 1324], [1174, 1196, 1202, 1277, 1296, 1360, 1369], [1197, 1202, 1242, 1276, 1288, 1366, 1369, 1390], [1213, 1223, 1252, 1312, 1323], [1224, 1230, 1246, 1247, 1299, 1341], [1165, 1225, 1265, 1315, 1334, 1376, 1386], [1181, 1264, 1271, 1331, 1352], [1227, 1254, 1260, 1303, 1318, 1325, 1332], [1244, 1307], [1187, 1212, 1229, 1285, 1308], [1187, 1212, 1216, 1284, 1309], [1263, 1301, 1342, 1359, 1372], [1207, 1235, 1253, 1270, 1324, 1330], [1203, 1242, 1277, 1292, 1346, 1366, 1370, 1375], [1290, 1301, 1316], [1289, 1306, 1316, 1328], [1226, 1269, 1293, 1329, 1355], [1203, 1288, 1297, 1346], [1226, 1291, 1302, 1317, 1355], [1221, 1239, 1274, 1275, 1343], [1201, 1266, 1271, 1313, 1340, 1345], [1196, 1255, 1276, 1360, 1363, 1389], [1203, 1250, 1292, 1335, 1346], [1243, 1261, 1304, 1307, 1327], [1246, 1268, 1279, 1314, 1341, 1377], [1238, 1248, 1315, 1342], [1286, 1289, 1316, 1350, 1359], [1234, 1257, 1293, 1306, 1317], [1260, 1266, 1282, 1313, 1325], [1250, 1261, 1298, 1327, 1347, 1358], [1228, 1262, 1311], [1234, 1290, 1302, 1317, 1328], [1283, 1298, 1327, 1336, 1364], [1228, 1229, 1284, 1311], [1176, 1216, 1285, 1310], [1176, 1252, 1309, 1322], [1228, 1305, 1308], [1278, 1323, 1365], [1266, 1295, 1303, 1325, 1340, 1374, 1379], [1268, 1299, 1377], [1225, 1232, 1248, 1280, 1300, 1342, 1376], [1289, 1290, 1301, 1328, 1338, 1350], [1293, 1302, 1306, 1328, 1355], [1254, 1282, 1332, 1333, 1356], [1240, 1449], [1245, 1273, 1348, 1381, 1438], [1186, 1241, 1267, 1349, 1392], [1252, 1310, 1323], [1252, 1278, 1312, 1322, 1365, 1382], [1253, 1275, 1287, 1330, 1397], [1282, 1303, 1313, 1332, 1362, 1379], [1241, 1262, 1392], [1298, 1304, 1307, 1358, 1364], [1290, 1306, 1316, 1317, 1338, 1367], [1269, 1291, 1339, 1355, 1426], [1270, 1287, 1324, 1351, 1383, 1397], [1271, 1281, 1352, 1378], [1282, 1318, 1325, 1356, 1362], [1254, 1318, 1356, 1357, 1384, 1406], [1231, 1256, 1265, 1280, 1386, 1433, 1456], [1250, 1297, 1346, 1347, 1375, 1380, 1411], [1307, 1337, 1364, 1371], [1336, 1371], [1316, 1328, 1350, 1367, 1373], [1220, 1269, 1274, 1329, 1361, 1422, 1426, 1472], [1295, 1313, 1345, 1374, 1393, 1404, 1413], [1247, 1279, 1299, 1353, 1377, 1419, 1482], [1233, 1238, 1263, 1286, 1300, 1315, 1372, 1376, 1470, 1521, 1568, 1583], [1274, 1294, 1368], [1249, 1258, 1351, 1354, 1387, 1403, 1409], [1271, 1295, 1340, 1378, 1393], [1288, 1292, 1297, 1335, 1375], [1250, 1304, 1335, 1358, 1380], [1267, 1273, 1320, 1349, 1381, 1385], [1267, 1321, 1348, 1385, 1392, 1432, 1439], [1301, 1316, 1338, 1359, 1373], [1249, 1270, 1330, 1344, 1383, 1403], [1264, 1281, 1331, 1354, 1378, 1387, 1409, 1410, 1420], [1247, 1256, 1341, 1433, 1482, 1565], [1258, 1259, 1264, 1344, 1352, 1387], [1291, 1293, 1317, 1329, 1426, 1471], [1318, 1332, 1333, 1362, 1384, 1394, 1405, 1407], [1254, 1272, 1333, 1388, 1406, 1415], [1304, 1327, 1347, 1364, 1380, 1391], [1286, 1301, 1350, 1372, 1373, 1402, 1424], [1276, 1296, 1369, 1389, 1437, 1443], [1274, 1339, 1368, 1422, 1434], [1325, 1332, 1356, 1379, 1394], [1237, 1255, 1296, 1389, 1395, 1400, 1418, 1430, 1436], [1307, 1327, 1336, 1358, 1371, 1391, 1412], [1312, 1323, 1382, 1417], [1277, 1288, 1370, 1390, 1401], [1328, 1338, 1373, 1402, 1425, 1442], [1274, 1343, 1361, 1434, 1452], [1276, 1277, 1360, 1390, 1443, 1444], [1288, 1366, 1375, 1401, 1462], [1336, 1337, 1364, 1412], [1286, 1342, 1359, 1424, 1466, 1514, 1568, 1569], [1338, 1350, 1359, 1367, 1402], [1313, 1340, 1379, 1404, 1414], [1288, 1335, 1346, 1370, 1411, 1451, 1462], [1280, 1315, 1342, 1386, 1470], [1299, 1314, 1341, 1408, 1419], [1271, 1331, 1345, 1352, 1393, 1410], [1313, 1325, 1362, 1374, 1394, 1414, 1428], [1335, 1347, 1358, 1391, 1411, 1421, 1431], [1320, 1348, 1385, 1416, 1438], [1323, 1365, 1417], [1330, 1351, 1397, 1403], [1333, 1356, 1405, 1406], [1348, 1349, 1381, 1416, 1423, 1439], [1280, 1334, 1376, 1456, 1470, 1529], [1344, 1352, 1354, 1409], [1272, 1357, 1398, 1415], [1296, 1360, 1363, 1430, 1437], [1277, 1366, 1369, 1401, 1444], [1358, 1364, 1380, 1412, 1421, 1455], [1241, 1321, 1326, 1349, 1432], [1340, 1345, 1378, 1410, 1413, 1440], [1356, 1362, 1379, 1407, 1428], [1237, 1272, 1363, 1399, 1435, 1436], [], [1324, 1330, 1383], [1272, 1388, 1399, 1415, 1441, 1447], [1272, 1395, 1398, 1435, 1441], [1363, 1418, 1430, 1448], [1366, 1370, 1390, 1444, 1462, 1487, 1497], [1359, 1367, 1373, 1424, 1425], [1344, 1351, 1383, 1409], [1340, 1374, 1413, 1414, 1427, 1459], [1356, 1384, 1406, 1407, 1445, 1446], [1333, 1357, 1384, 1405, 1415, 1429, 1446], [1356, 1394, 1405, 1428, 1445, 1450], [1377, 1419, 1508], [1344, 1352, 1387, 1403, 1420], [1352, 1378, 1393, 1420, 1440, 1454], [1335, 1375, 1380, 1431, 1451, 1465], [1364, 1371, 1391, 1455], [1340, 1393, 1404, 1440, 1459], [1374, 1379, 1404, 1427, 1428, 1460], [1357, 1388, 1398, 1406, 1429, 1447, 1461], [1381, 1385, 1423, 1438, 1499, 1539, 1563], [1365, 1382], [1363, 1400, 1436, 1448], [1341, 1377, 1408, 1482, 1508, 1520, 1535], [1352, 1409, 1410, 1454], [1380, 1391, 1431, 1455, 1477], [1339, 1361, 1434, 1472, 1483, 1546, 1558], [1385, 1416, 1439, 1499], [1359, 1372, 1402, 1425, 1466], [1367, 1402, 1424, 1442, 1466], [1329, 1339, 1355, 1471, 1472], [1404, 1414, 1459, 1460, 1467], [1379, 1394, 1407, 1414, 1450, 1460, 1468, 1474], [1406, 1415, 1445, 1446, 1461, 1485, 1496], [1363, 1389, 1400, 1437, 1448, 1464, 1469, 1509], [1380, 1411, 1421, 1465, 1477, 1480], [1349, 1392, 1439, 1488], [1256, 1334, 1353, 1456, 1565, 1599, 1648], [1361, 1368, 1422, 1452, 1483, 1491], [1395, 1399, 1436, 1441, 1458], [1363, 1395, 1418, 1435, 1448, 1458], [1360, 1389, 1430, 1443, 1464], [1320, 1381, 1416, 1539, 1574], [1349, 1385, 1423, 1432, 1488, 1499], [1393, 1410, 1413, 1454, 1459, 1494], [1398, 1399, 1435, 1447, 1458, 1463, 1475, 1500, 1501], [1367, 1425, 1466, 1504], [1360, 1369, 1437, 1444, 1464, 1486, 1493], [1369, 1390, 1401, 1443, 1493, 1497], [1405, 1407, 1429, 1446, 1450, 1468, 1485], [1405, 1406, 1429, 1445], [1398, 1415, 1441, 1461, 1463, 1492], [1400, 1418, 1430, 1436, 1458, 1469, 1473, 1476], [1319], [1407, 1428, 1445, 1468], [1375, 1411, 1462, 1465, 1503, 1512, 1513], [1368, 1434, 1457, 1491], [1484, 1489], [1410, 1420, 1440, 1494], [1391, 1412, 1421, 1477], [1334, 1386, 1433, 1529, 1599], [1452, 1491], [1435, 1436, 1441, 1448, 1473, 1475, 1479], [1404, 1413, 1427, 1440, 1467, 1490, 1494, 1495], [1414, 1427, 1428, 1467, 1474, 1502], [1415, 1429, 1447, 1492, 1496], [1370, 1375, 1401, 1451, 1487, 1511, 1512], [1441, 1447, 1492, 1500, 1517], [1430, 1437, 1443, 1486, 1509, 1510, 1519], [1411, 1431, 1451, 1480, 1503], [1372, 1424, 1425, 1442, 1504, 1514], [1427, 1459, 1460, 1490, 1502], [1428, 1445, 1450, 1474, 1485, 1506], [1430, 1448, 1476, 1509, 1518], [1342, 1376, 1386, 1521, 1529], [1355, 1426, 1472, 1536, 1571], [1339, 1422, 1426, 1471, 1536, 1558], [1448, 1458, 1476, 1479, 1507], [1428, 1460, 1468, 1502, 1506, 1516], [1441, 1458, 1479, 1501], [1448, 1469, 1473, 1507, 1518], [1421, 1431, 1455, 1480], [1498], [1458, 1473, 1475, 1501, 1507], [1431, 1465, 1477, 1503, 1553], [], [1341, 1353, 1419, 1520, 1565, 1567], [1422, 1434, 1491, 1523, 1546], [1453, 1489, 1505, 1515, 1522], [1429, 1445, 1468, 1496, 1506, 1528, 1537], [1443, 1464, 1493, 1510, 1550], [1401, 1462, 1497, 1511, 1534], [1432, 1439, 1499, 1556], [1453, 1484, 1515, 1524], [1459, 1467, 1495, 1502, 1527, 1530], [1434, 1452, 1457, 1483, 1505, 1523], [1447, 1461, 1463, 1496, 1517], [1443, 1444, 1486, 1497, 1550], [1440, 1454, 1459, 1495, 1531], [1459, 1490, 1494, 1527, 1531, 1532], [1429, 1461, 1485, 1492, 1517, 1528, 1543, 1548, 1559], [1401, 1444, 1487, 1493, 1534, 1550, 1551, 1560], [1478, 1526], [1416, 1423, 1439, 1488, 1556, 1563, 1564], [1441, 1463, 1501, 1517, 1533, 1543], [1441, 1475, 1479, 1500, 1507, 1525, 1533], [1460, 1467, 1474, 1490, 1516, 1530], [1451, 1465, 1480, 1513, 1544, 1553], [1442, 1466, 1514, 1566, 1570], [1484, 1491, 1522, 1523], [1468, 1474, 1485, 1516, 1537, 1542], [1473, 1476, 1479, 1501, 1518, 1525], [1408, 1419, 1535, 1588], [1430, 1464, 1469, 1518, 1519, 1549, 1573], [1464, 1486, 1519, 1550, 1561, 1562], [1462, 1487, 1512, 1534, 1552, 1578], [1451, 1462, 1511, 1513, 1552, 1555], [1451, 1503, 1512, 1555], [1372, 1466, 1504, 1569, 1570], [1484, 1489, 1522, 1523, 1524, 1540, 1596], [1474, 1502, 1506, 1530, 1542], [1463, 1492, 1496, 1500, 1543], [1469, 1476, 1507, 1509, 1525, 1573, 1589], [1464, 1509, 1510, 1549, 1561], [1419, 1482, 1535, 1567, 1640, 1647, 1677], [1342, 1470, 1529, 1583, 1616], [1484, 1505, 1515, 1523], [1483, 1491, 1505, 1515, 1522, 1546, 1596, 1633, 1650, 1661], [1489, 1515, 1540], [1501, 1507, 1518, 1589], [1498], [1490, 1495, 1530, 1532, 1547, 1575], [1485, 1496, 1537, 1548, 1572], [1386, 1456, 1470, 1521, 1599, 1616, 1645, 1668], [1490, 1502, 1516, 1527, 1542, 1575, 1580], [1494, 1495, 1532, 1541, 1554, 1579], [1495, 1527, 1531, 1547, 1554], [1500, 1501], [1487, 1497, 1511, 1551, 1577, 1578], [1419, 1508, 1520, 1588, 1640], [1471, 1472, 1558, 1571], [1485, 1506, 1528, 1542, 1572, 1581], [1545, 1557], [1416, 1438, 1563, 1574, 1594, 1597], [1515, 1524, 1596], [1531, 1579], [1506, 1516, 1530, 1537, 1580, 1581, 1592], [1496, 1500, 1517, 1559, 1576], [1503], [1538, 1557, 1582, 1586], [1422, 1483, 1523, 1558, 1613, 1650], [1527, 1532, 1575, 1584], [1496, 1528, 1559, 1572, 1604], [1509, 1519, 1561, 1573, 1610, 1642], [1486, 1493, 1497, 1510, 1560, 1562], [1497, 1534, 1560, 1577, 1593, 1602], [1511, 1512, 1555, 1578], [1480, 1503], [1531, 1532, 1579], [1512, 1513, 1552], [1488, 1499, 1564, 1595], [1538, 1545, 1582], [1422, 1472, 1536, 1546, 1571, 1613], [1496, 1543, 1548, 1576, 1601, 1604, 1621], [1497, 1550, 1551, 1562, 1593, 1611], [1510, 1519, 1549, 1562, 1610], [1510, 1550, 1560, 1561, 1610, 1611, 1628], [1416, 1499, 1539, 1564, 1597, 1598, 1606], [1499, 1556, 1563, 1595, 1598], [1353, 1433, 1482, 1567, 1648, 1659, 1660, 1700], [1504, 1570, 1620, 1685, 1689, 1701], [1482, 1520, 1565, 1647, 1659], [1342, 1372, 1569, 1583, 1617, 1646, 1731, 1742, 1749], [1372, 1514, 1568, 1570, 1617], [1504, 1514, 1566, 1569, 1617, 1620], [1471, 1536, 1558, 1613, 1649], [1528, 1537, 1548, 1581, 1603, 1604, 1609], [1509, 1518, 1549, 1589, 1627, 1642], [1438, 1539, 1594, 1622], [1527, 1530, 1547, 1580, 1584, 1600, 1614, 1626], [1543, 1559, 1601], [1534, 1551, 1578, 1602, 1612], [1511, 1534, 1552, 1577, 1612], [1531, 1541, 1554], [1530, 1542, 1575, 1592, 1600], [1537, 1542, 1572, 1592, 1603], [1545, 1557, 1586, 1608], [1342, 1521, 1568, 1616, 1749, 1752, 1768], [1547, 1575, 1614], [1587, 1591, 1637], [1545, 1582, 1608], [1585, 1591], [1508, 1535, 1640, 1665, 1712, 1726], [1518, 1525, 1573, 1627], [1591, 1631], [1585, 1587, 1590, 1631, 1637], [1542, 1580, 1581, 1600, 1603, 1634, 1638], [1551, 1560, 1602, 1611, 1643], [1539, 1574, 1597, 1605, 1615, 1622], [1556, 1564, 1598, 1607, 1624], [1515, 1523, 1540, 1633], [1539, 1563, 1594, 1605, 1606, 1623], [1563, 1564, 1595, 1606, 1607, 1619], [1433, 1456, 1529, 1645, 1648, 1697, 1705], [1575, 1580, 1592, 1626, 1638, 1641, 1651], [1559, 1576, 1621], [1551, 1577, 1593, 1612, 1643, 1656], [1572, 1581, 1592, 1609, 1634, 1654], [1548, 1559, 1572, 1609, 1621, 1655], [1594, 1597, 1615, 1623], [1563, 1597, 1598, 1619, 1623, 1663], [1595, 1598, 1619, 1624, 1636], [1582, 1586], [1572, 1603, 1604, 1654, 1655], [1549, 1561, 1562, 1628, 1642, 1678], [1560, 1562, 1593, 1628, 1643, 1680, 1681, 1711], [1577, 1578, 1602, 1656, 1662], [1546, 1558, 1571, 1649, 1650, 1672], [1575, 1584, 1626, 1666], [1594, 1605, 1622, 1623, 1652], [1521, 1529, 1583, 1668, 1722, 1752], [1568, 1569, 1570, 1620, 1646], [], [1598, 1606, 1607, 1636, 1644, 1663], [1566, 1570, 1617, 1646, 1685, 1693], [1559, 1601, 1604, 1655], [1574, 1594, 1615, 1652], [1597, 1605, 1606, 1615, 1652, 1663, 1682, 1694], [1595, 1607, 1636, 1644, 1664], [1632, 1639, 1657], [1575, 1600, 1614, 1641, 1666, 1690, 1691], [1573, 1589, 1642, 1687], [1562, 1610, 1611, 1678, 1680], [1630], [1629], [1590, 1591, 1637, 1653], [1625, 1639, 1658], [1523, 1596, 1661, 1686], [1592, 1603, 1638, 1654, 1679], [], [1607, 1619, 1624, 1644], [1585, 1591, 1631, 1653, 1675], [1592, 1600, 1634, 1651, 1679], [1625, 1632, 1657, 1658], [1520, 1535, 1588, 1677, 1712], [1600, 1626, 1651, 1691], [1549, 1573, 1610, 1627, 1678, 1687, 1688], [1593, 1602, 1611, 1656, 1673, 1681], [1619, 1624, 1636, 1663, 1664, 1670, 1683], [1529, 1599, 1668, 1697, 1714], [1568, 1617, 1620, 1693, 1718, 1742, 1762, 1763], [1520, 1567, 1659, 1677, 1713, 1730], [1433, 1565, 1599, 1700, 1705, 1761], [1571, 1613, 1672, 1702, 1723], [1523, 1546, 1613, 1661, 1672, 1706], [1600, 1638, 1641, 1679, 1691, 1734], [1615, 1622, 1623, 1682], [1631, 1637, 1667, 1675, 1696], [1603, 1609, 1634, 1655, 1679, 1698, 1724], [1604, 1609, 1621, 1654, 1698], [1602, 1612, 1643, 1662, 1673, 1704], [1625, 1639], [1632, 1639], [1565, 1567, 1647, 1660, 1713], [1565, 1659, 1700, 1713, 1727], [1523, 1633, 1650, 1686, 1706, 1756], [1612, 1656, 1704, 1708], [1606, 1619, 1623, 1644, 1670, 1692, 1694], [1624, 1644, 1683, 1684], [1588, 1720, 1726], [1614, 1626, 1690, 1703], [1653, 1684, 1695, 1696, 1699], [1529, 1616, 1645, 1714, 1721, 1722, 1741], [1674, 1719], [1644, 1663, 1683, 1692, 1709], [], [1613, 1649, 1650, 1702, 1706], [1643, 1656, 1681, 1704, 1716, 1736, 1737], [1669, 1719], [1637, 1653, 1696, 1729], [], [1520, 1640, 1647, 1712, 1730, 1759, 1760], [1610, 1628, 1642, 1680, 1688, 1707], [1634, 1638, 1651, 1654, 1724, 1734, 1735], [1611, 1628, 1678, 1707, 1711, 1715], [1611, 1643, 1673, 1711, 1716], [1623, 1652, 1694], [1644, 1664, 1670, 1684, 1709, 1710], [1664, 1667, 1683, 1695, 1710], [1566, 1620, 1693, 1701, 1732, 1753, 1787], [1633, 1661, 1756], [1627, 1642, 1688], [1642, 1678, 1687], [1566, 1701, 1753, 1755, 1779, 1782], [1626, 1666, 1691, 1703, 1733, 1743], [1626, 1641, 1651, 1690, 1733, 1734], [1663, 1670, 1694, 1709], [1620, 1646, 1685, 1718, 1732], [1623, 1663, 1682, 1692], [1667, 1684, 1699, 1710, 1717], [1653, 1667, 1675, 1699, 1729], [1599, 1645, 1705, 1714, 1770, 1778], [1654, 1655, 1724], [1667, 1695, 1696, 1717, 1729, 1739], [1565, 1648, 1660, 1727, 1761, 1767], [1566, 1685, 1689, 1753], [1649, 1672, 1706, 1723, 1756], [1666, 1690, 1743], [1656, 1662, 1673, 1708, 1728, 1737], [1599, 1648, 1697, 1761, 1770, 1792], [1650, 1661, 1672, 1702, 1756], [1678, 1680, 1715, 1750, 1771], [1662, 1704, 1728, 1738], [1670, 1683, 1692, 1710], [1683, 1684, 1695, 1709], [1611, 1680, 1681, 1715, 1716, 1744], [1588, 1640, 1677, 1726, 1759, 1773, 1777], [1647, 1659, 1660, 1727, 1730, 1740, 1751], [1645, 1668, 1697, 1721, 1778, 1786], [1680, 1707, 1711, 1744, 1750], [1673, 1681, 1711, 1736, 1737, 1744], [1695, 1699, 1739], [1646, 1693, 1732, 1763], [1669, 1674, 1746], [1665, 1726, 1748, 1809], [1668, 1714, 1741, 1781, 1786], [1616, 1668, 1741, 1752, 1807], [1649, 1702, 1756, 1793], [1654, 1679, 1698, 1735, 1757], [], [1588, 1665, 1712, 1720, 1748, 1773], [1660, 1700, 1713, 1740, 1767], [1704, 1708, 1737, 1738, 1774, 1783, 1795], [1675, 1696, 1699, 1739, 1747, 1765], [1647, 1677, 1713, 1751, 1760, 1785], [1568, 1742, 1749, 1803, 1810], [1685, 1693, 1718, 1763, 1787, 1811, 1823, 1859], [1690, 1691, 1734, 1743, 1764, 1769, 1788], [1651, 1679, 1691, 1733, 1735, 1764], [1679, 1724, 1734, 1757, 1764, 1766], [1673, 1716, 1737, 1744, 1789, 1794, 1795], [1673, 1704, 1716, 1728, 1736, 1795], [1708, 1728, 1774, 1780], [1699, 1717, 1729, 1765], [1713, 1727, 1751, 1767, 1785, 1791], [1668, 1721, 1722, 1781, 1806], [1568, 1646, 1731, 1762, 1810, 1834], [1690, 1703, 1733, 1769], [1711, 1715, 1716, 1736, 1750, 1789, 1825], [1747, 1758, 1772, 1776], [1719, 1775], [1729, 1745, 1758, 1765, 1784, 1790], [1720, 1726, 1773, 1809], [1568, 1583, 1731, 1768, 1803], [1707, 1715, 1744, 1771, 1825], [1713, 1730, 1740, 1785], [1583, 1616, 1722, 1768, 1807], [1685, 1689, 1701, 1779, 1787], [], [1689, 1782, 1817, 1833, 1841], [1661, 1686, 1702, 1706, 1723, 1793], [1724, 1735, 1766, 1800, 1801], [1745, 1747, 1776, 1790, 1799], [1677, 1712, 1760, 1777, 1798], [1677, 1730, 1759, 1785, 1798, 1814, 1820, 1827], [1648, 1700, 1705, 1767, 1792, 1821], [1646, 1742, 1763, 1823, 1834], [1646, 1718, 1732, 1762, 1823], [1733, 1734, 1735, 1766, 1788, 1808], [1729, 1739, 1747, 1784], [1735, 1757, 1764, 1800, 1808], [1700, 1727, 1740, 1761, 1791, 1792, 1804, 1821], [1583, 1749, 1752, 1803, 1807, 1881, 1889], [1733, 1743, 1788, 1812], [1697, 1705, 1778, 1792, 1802, 1845], [1707, 1750, 1825, 1835], [1745, 1776, 1843], [1712, 1726, 1748, 1777, 1809, 1826, 1839], [1728, 1738, 1780, 1783, 1813, 1831, 1861, 1864], [1746], [1745, 1758, 1772, 1799, 1843], [1712, 1759, 1773, 1798, 1839, 1849], [1697, 1714, 1770, 1786, 1802, 1805, 1822], [1689, 1753, 1782, 1787, 1824], [1738, 1774, 1831], [1721, 1741, 1786, 1806, 1815, 1816], [1689, 1755, 1779, 1817, 1824], [1728, 1774, 1795, 1813], [1747, 1765, 1790], [1730, 1740, 1751, 1760, 1791, 1814], [1714, 1721, 1778, 1781, 1815, 1822, 1832], [1685, 1732, 1753, 1779, 1811, 1824, 1840], [1733, 1764, 1769, 1808, 1812, 1830], [1736, 1744, 1794, 1847], [1747, 1758, 1784, 1799], [1740, 1767, 1785, 1804, 1814, 1828, 1844, 1856], [1705, 1761, 1767, 1770, 1821, 1845], [1723, 1756], [1736, 1789, 1795, 1847], [1728, 1736, 1737, 1783, 1794, 1813, 1847, 1851], [], [], [1759, 1760, 1777, 1827, 1849], [1758, 1776, 1790, 1843], [1757, 1766, 1801, 1808, 1842, 1846, 1850], [1757, 1800, 1842], [1770, 1778, 1805, 1845, 1867], [1731, 1749, 1768, 1810, 1889, 1901], [1767, 1791, 1821, 1828, 1857], [1778, 1802, 1822, 1866, 1867], [1741, 1781, 1816, 1837, 1873], [1722, 1752, 1768, 1829, 1881], [1764, 1766, 1788, 1800, 1830, 1846], [1720, 1748, 1773, 1826], [1731, 1742, 1803, 1834, 1901, 1923], [1732, 1787, 1840, 1859], [1769, 1788, 1830, 1854], [1774, 1783, 1795, 1851, 1861], [1760, 1785, 1791, 1820, 1844, 1900], [1781, 1786, 1816, 1832, 1868, 1880], [1781, 1806, 1815, 1873, 1880], [1755, 1782, 1824, 1833, 1863, 1882], [], [], [1760, 1814, 1827, 1900], [1761, 1767, 1792, 1804, 1845, 1857, 1879], [1778, 1786, 1805, 1832, 1866], [1732, 1762, 1763, 1834, 1858, 1859, 1894], [1779, 1782, 1787, 1817, 1840, 1863], [1744, 1750, 1771, 1835, 1896], [1773, 1809, 1838, 1839], [1760, 1798, 1820, 1849, 1900], [1791, 1804, 1856, 1857], [1807, 1837, 1881, 1921], [1788, 1808, 1812, 1846, 1854], [1774, 1780, 1864], [1786, 1815, 1822, 1866, 1868], [1755, 1817, 1841, 1882, 1890, 1911], [1742, 1762, 1810, 1823, 1858, 1923], [1771, 1825, 1896], [], [1806, 1829, 1873, 1921, 1926], [1826, 1839, 1865], [1773, 1777, 1826, 1838, 1849, 1865], [1787, 1811, 1824, 1862, 1863], [1755, 1833, 1874, 1890], [1800, 1801, 1850, 1870, 1891], [1772, 1776, 1799, 1885], [1791, 1814, 1856, 1900, 1919], [1770, 1792, 1802, 1821, 1867, 1879, 1888], [1800, 1808, 1830, 1850, 1854, 1870, 1902, 1909], [1789, 1794, 1795, 1851], [], [1777, 1798, 1827, 1839, 1865, 1900, 1904], [1800, 1842, 1846, 1870], [1795, 1813, 1847, 1861, 1897, 1910], [], [1875, 1877], [1812, 1830, 1846, 1902], [1886, 1893, 1913], [1791, 1828, 1844, 1857, 1887, 1919], [1804, 1821, 1828, 1856, 1878, 1879, 1887], [1823, 1834, 1894, 1923, 1940, 1957], [1732, 1811, 1823, 1862, 1894, 1908], [1869, 1918], [1774, 1813, 1851, 1864, 1897], [1840, 1859, 1863, 1906, 1908], [1817, 1824, 1840, 1862, 1882, 1906], [1774, 1831, 1861], [1838, 1839, 1849, 1904], [1805, 1822, 1832, 1867, 1868, 1905, 1933], [1802, 1805, 1845, 1866, 1888, 1905], [1815, 1832, 1866, 1880, 1933], [1860, 1876, 1918], [1842, 1846, 1850, 1891, 1909], [], [], [1806, 1816, 1837, 1880, 1917, 1926, 1939], [1841, 1890, 1907, 1934], [1853, 1877, 1886, 1943, 1951], [1869, 1883, 1918, 1922], [1853, 1875, 1903, 1943], [1857, 1879, 1887, 1946, 1952], [1821, 1845, 1857, 1878, 1888, 1915, 1952], [1815, 1816, 1868, 1873, 1917, 1933], [1768, 1807, 1829, 1889, 1921, 1956, 1974], [1817, 1833, 1863, 1906, 1911, 1949], [1876, 1895, 1922], [], [1843, 1912], [1855, 1875, 1913, 1944, 1951], [1856, 1857, 1878, 1919, 1945, 1946], [1845, 1867, 1879, 1905, 1915, 1916, 1920], [1768, 1803, 1881, 1901, 1956, 1994, 2018, 2020], [1833, 1841, 1874, 1911, 1934], [1842, 1870, 1909], [], [1855, 1898, 1913, 1924], [1823, 1858, 1859, 1908, 1941, 1957], [1883, 1907, 1922], [1825, 1835, 1929, 1942], [1851, 1861, 1910], [1893, 1914, 1924, 1925], [], [1814, 1820, 1827, 1844, 1849, 1904, 1919, 1938], [1803, 1810, 1889, 1923, 2018], [1846, 1854, 1909, 1928], [1877, 1943, 1954, 1965], [1849, 1865, 1900, 1938, 1958, 1977], [1866, 1867, 1888, 1920, 1933, 1947], [1862, 1863, 1882, 1908, 1941, 1949, 1959], [1874, 1895, 1922, 1934], [1859, 1862, 1894, 1906, 1941], [1846, 1870, 1891, 1902, 1928, 1935], [1851, 1897], [1833, 1882, 1890, 1934, 1949, 1963], [1885, 1927], [1855, 1886, 1893, 1924, 1944, 1970], [1898, 1925, 1937, 1955], [1879, 1888, 1916, 1952, 1972], [1888, 1915, 1920, 1972], [1873, 1880, 1933, 1939, 1962, 1985, 1988], [1860, 1869, 1876, 1922, 1950], [1844, 1856, 1887, 1900, 1938, 1945], [1888, 1905, 1916, 1947, 1972, 1982], [1829, 1837, 1881, 1926, 1974], [1876, 1883, 1895, 1907, 1918, 1934, 1950, 1960], [1810, 1834, 1858, 1901, 1940, 2007, 2018], [1893, 1898, 1913, 1925, 1966, 1970, 1971], [1898, 1914, 1924, 1937, 1966], [1837, 1873, 1921, 1939, 1974, 1988, 2003, 2009], [1912, 1932], [1902, 1909, 1935], [1896, 1942, 1996], [1961, 1967, 1976], [], [1927, 1954], [1866, 1868, 1880, 1905, 1917, 1947, 1962], [1874, 1890, 1907, 1911, 1922, 1960, 1963, 1979], [1909, 1928], [1953, 1968], [1914, 1925, 1955, 1966, 1983, 2015], [1900, 1904, 1919, 1945, 1977, 1990], [1873, 1917, 1926, 1988], [1858, 1923, 1957, 1964, 2007], [1894, 1906, 1908, 1957, 1959, 1964, 1975], [1896, 1929, 1992, 1996], [1875, 1877, 1903, 1951, 1965, 1993, 2001, 2014], [1886, 1913, 1951, 1970], [1887, 1919, 1938, 1946, 1978, 1990], [1878, 1887, 1945, 1952, 1978, 1981], [1905, 1920, 1933, 1962, 1973, 1982, 1987], [], [1882, 1906, 1911, 1959, 1963], [1918, 1922, 1960, 1980, 1991], [1875, 1886, 1943, 1944, 1970, 1993], [1878, 1879, 1915, 1946, 1981], [1936, 1968], [1903, 1932, 1965, 1995], [1914, 1937, 1983, 1984], [1881, 1889, 1974, 1994], [1858, 1894, 1940, 1941, 1964], [1904, 1977], [1906, 1941, 1949, 1963, 1975, 1986], [1922, 1934, 1950, 1979, 1980, 1999], [1930, 1976], [1917, 1933, 1947, 1973, 1985, 1987], [1911, 1934, 1949, 1959, 1979, 1986, 1998], [1940, 1941, 1957, 1975, 2007], [1903, 1943, 1954, 1995, 2001], [1924, 1925, 1937, 1971, 2015], [1930, 1976], [1936, 1953], [], [1913, 1924, 1944, 1951, 1971, 1993, 2005], [1924, 1966, 1970, 2005, 2015, 2052, 2057], [1915, 1916, 1920, 1982], [1947, 1962, 1987], [1881, 1921, 1926, 1956, 1994, 2003, 2043], [1941, 1959, 1964, 1986, 2007, 2029, 2032], [1930, 1961, 1967], [1904, 1938, 1958, 1990], [1945, 1946, 1981, 1990, 2006], [1934, 1960, 1963, 1998, 1999, 2021, 2023], [1950, 1960, 1991, 1999], [1946, 1952, 1978, 2006], [1920, 1947, 1972, 1987], [1937, 1955, 1984, 2015, 2017, 2050], [1955, 1983, 2002, 2017], [1917, 1962, 1987, 1988], [1959, 1963, 1975, 1998, 2032], [1947, 1962, 1973, 1982, 1985], [1917, 1926, 1939, 1985, 2009], [2000, 2025, 2031, 2035, 2038], [1938, 1945, 1977, 1978, 2006], [1950, 1980, 1999, 2016], [1942, 1996, 2004, 2010], [1943, 1951, 1970, 2005, 2014, 2026], [1889, 1956, 1974, 2020, 2043], [1954, 1965, 2001, 2028], [1929, 1942, 1992, 2010], [], [1963, 1979, 1986, 2023, 2032], [1960, 1979, 1980, 1991, 2016, 2021, 2034], [1989, 2035], [1943, 1965, 1995, 2014, 2022, 2028], [1984, 2008, 2017], [1926, 1974, 2009, 2043, 2053], [1992, 2010, 2011, 2027], [1970, 1971, 1993, 2026, 2048, 2057], [1978, 1981, 1990], [1923, 1940, 1964, 1975, 2018, 2029, 2036], [2002, 2017, 2030, 2050], [1926, 1988, 2003, 2053, 2060], [1992, 1996, 2004, 2027, 2042], [2004, 2027], [], [2019, 2033], [1943, 1993, 2001, 2022, 2026], [1937, 1966, 1971, 1983, 2050, 2052], [1991, 1999, 2034], [1983, 1984, 2002, 2008, 2050], [1889, 1901, 1923, 2007, 2020, 2036, 2064, 2075, 2083], [2013, 2024, 2033], [1889, 1994, 2018, 2043, 2083, 2098, 2111, 2126], [1979, 1999, 2023, 2034, 2040, 2045], [2001, 2014, 2026, 2028, 2044, 2047], [1979, 1998, 2021, 2032, 2040, 2051], [2019, 2033, 2041, 2046], [1989, 2031], [1993, 2005, 2014, 2022, 2044, 2048], [2004, 2010, 2011, 2042, 2049, 2055], [1995, 2001, 2022, 2047, 2067], [1975, 2007, 2032, 2036, 2071, 2103], [2008, 2050, 2062], [1989, 2025, 2038, 2061, 2063], [1975, 1986, 1998, 2023, 2029, 2051, 2071, 2092, 2099, 2102], [2013, 2019, 2024, 2041, 2046], [1999, 2016, 2021, 2045], [1989, 2000, 2038, 2056], [2007, 2018, 2029, 2064], [], [1989, 2031, 2035, 2056, 2063], [], [2021, 2023, 2045, 2051, 2058, 2072], [2024, 2033, 2046, 2054], [2010, 2027, 2049], [1974, 1994, 2003, 2020, 2053, 2070, 2098], [2022, 2026, 2047, 2048, 2077, 2082, 2084, 2086], [2021, 2034, 2040, 2058], [2024, 2033, 2041, 2054, 2073], [2022, 2028, 2044, 2067, 2077], [2005, 2026, 2044, 2057, 2084], [2027, 2042, 2055], [1983, 2008, 2015, 2017, 2030, 2052, 2062, 2089, 2105, 2115], [2023, 2032, 2040, 2072, 2080, 2092], [1971, 2015, 2050, 2057, 2115], [2003, 2009, 2043, 2060, 2070, 2078, 2106], [2041, 2046, 2073, 2074], [2027, 2049, 2068], [2035, 2038, 2063, 2081], [1971, 2005, 2048, 2052, 2084, 2115, 2139, 2153], [2040, 2045, 2072], [2069], [2009, 2053, 2078], [2031, 2063, 2065], [2030, 2050, 2089], [2031, 2038, 2056, 2061, 2065, 2081, 2090, 2091, 2108, 2109, 2110], [2018, 2036, 2075, 2101, 2107], [2061, 2063, 2090], [2079], [2028, 2047, 2077, 2097], [2055], [2059], [2043, 2053, 2098, 2106], [2029, 2032, 2102, 2103, 2120], [2040, 2051, 2058, 2080], [2046, 2054, 2074, 2085], [2054, 2073, 2085, 2087], [2018, 2064, 2083, 2107, 2127], [2079, 2096, 2119], [2044, 2047, 2067, 2082, 2097, 2118], [2053, 2060, 2106, 2142], [2066, 2076], [2051, 2072, 2092], [2056, 2063, 2091], [2044, 2077, 2086, 2114, 2118], [2018, 2020, 2075, 2111, 2162], [2044, 2048, 2057, 2086, 2139], [2073, 2074, 2087, 2093, 2121], [2044, 2082, 2084, 2114, 2139, 2147], [2074, 2085, 2093], [2089], [2050, 2062, 2088, 2105, 2116, 2151], [2063, 2065, 2108], [2063, 2081, 2110], [2032, 2051, 2080, 2099], [2085, 2087, 2121, 2122, 2137], [2124], [2100, 2116, 2132], [2076, 2119, 2123], [2067, 2077, 2118, 2140], [2020, 2043, 2070, 2106, 2126, 2136, 2152], [2032, 2092, 2102], [2095, 2125, 2132, 2141], [2064, 2103, 2107, 2127, 2143, 2144], [2032, 2071, 2099, 2120], [2029, 2071, 2101, 2120, 2144, 2145, 2159], [], [2050, 2089, 2115, 2151, 2167], [2053, 2070, 2078, 2098, 2136, 2142, 2156], [2064, 2075, 2101, 2127], [2063, 2090, 2109], [2063, 2108, 2110], [2063, 2091, 2109], [2020, 2083, 2126, 2162, 2189], [], [2124, 2130, 2146, 2166, 2173], [2082, 2086, 2118, 2131, 2147, 2157], [2050, 2052, 2057, 2105, 2153, 2167], [2089, 2095, 2132, 2151], [], [2077, 2082, 2097, 2114, 2131, 2140, 2161], [2076, 2096, 2123, 2149], [2071, 2102, 2103, 2145], [2085, 2093, 2137], [2093, 2137, 2148], [2096, 2119], [2094, 2113, 2146], [2100, 2133, 2141, 2150], [2020, 2098, 2111, 2152, 2189, 2192], [2075, 2101, 2107, 2143], [], [2133, 2158, 2165, 2168], [2113, 2166, 2171, 2174], [2114, 2118, 2157, 2161, 2164], [2095, 2100, 2116, 2141, 2151, 2163], [2125, 2129, 2150, 2165], [], [], [2098, 2106, 2152, 2156, 2178], [2093, 2121, 2122, 2148], [], [2057, 2084, 2086, 2147, 2153, 2169, 2195, 2206], [2097, 2118, 2161], [2100, 2125, 2132, 2150, 2163, 2183], [2078, 2106, 2156], [2101, 2127, 2144, 2199], [2101, 2103, 2143, 2159, 2199], [2103, 2120, 2159, 2170], [2113, 2124, 2173], [2086, 2114, 2139, 2157, 2169], [2122, 2137], [2119], [2125, 2133, 2141, 2165, 2183, 2185], [2089, 2105, 2116, 2132, 2163, 2167, 2221, 2230, 2234], [2098, 2126, 2136, 2177, 2178, 2192], [2057, 2115, 2139, 2167, 2206, 2217], [], [], [2106, 2136, 2142, 2177, 2178], [2114, 2131, 2147, 2164, 2169, 2182], [2129, 2168, 2176, 2179], [2103, 2144, 2145, 2170, 2186, 2199], [], [2118, 2131, 2140, 2164, 2175], [2083, 2111, 2189, 2209, 2222], [2132, 2141, 2151, 2183, 2185, 2221], [2131, 2157, 2161, 2175, 2182, 2191], [2129, 2133, 2150, 2168, 2185, 2202, 2220], [2113, 2130, 2171, 2173], [2105, 2115, 2151, 2153, 2217, 2234, 2239, 2243], [2129, 2158, 2165, 2179, 2202], [2139, 2147, 2157, 2182, 2195, 2208, 2216], [2145, 2159, 2186], [2130, 2166, 2174, 2207], [], [2113, 2146, 2166], [2130, 2171, 2207], [2161, 2164, 2191], [2158, 2179, 2198], [2152, 2156, 2178, 2192, 2231, 2244, 2253], [2136, 2152, 2156, 2177], [2158, 2168, 2176, 2198, 2202, 2211], [2181, 2190], [2180, 2184, 2190], [2157, 2164, 2169, 2191, 2215, 2216], [2141, 2150, 2163, 2185], [2181, 2190, 2193, 2196], [2150, 2163, 2165, 2183, 2220, 2221, 2235], [2159, 2170, 2199, 2204], [2193, 2194, 2200, 2201], [], [2111, 2126, 2162, 2192, 2222, 2244, 2251], [2180, 2181, 2184, 2196], [2164, 2175, 2182, 2215, 2229], [2126, 2152, 2177, 2189, 2244], [2184, 2187, 2196, 2200, 2203], [2187, 2201], [2139, 2169, 2206, 2208, 2233, 2246], [2184, 2190, 2193, 2203], [], [2176, 2179, 2211], [2143, 2144, 2159, 2186, 2204, 2209, 2227, 2228, 2252], [2187, 2193, 2201, 2203], [2187, 2194, 2200, 2205], [2165, 2168, 2179, 2211, 2220, 2224, 2226], [2193, 2196, 2200], [2186, 2199, 2228], [2201, 2210], [2139, 2153, 2195, 2217, 2233, 2238], [2171, 2174], [2169, 2195, 2216, 2237, 2246, 2255, 2256], [2162, 2199, 2223, 2227, 2258, 2277, 2282], [2205], [2179, 2198, 2202, 2226], [], [], [], [2182, 2191, 2216, 2229, 2237, 2248], [2169, 2182, 2208, 2215, 2237], [2153, 2167, 2206, 2238, 2243, 2265], [], [2225], [2165, 2185, 2202, 2224, 2235, 2236, 2254, 2257], [2151, 2163, 2185, 2230, 2235, 2261], [2162, 2189, 2223, 2251, 2258], [2209, 2222, 2258], [2202, 2220, 2226, 2236], [2219], [2202, 2211, 2224, 2236, 2250], [2199, 2209, 2271, 2277, 2279], [2199, 2204, 2240, 2252], [2191, 2215, 2248], [2151, 2221, 2234, 2261, 2267], [2177, 2253, 2274, 2311, 2312], [], [2195, 2206, 2238, 2246, 2269, 2273, 2275], [2151, 2167, 2230, 2239, 2267, 2276], [2185, 2220, 2221, 2254, 2261, 2278], [2220, 2224, 2226, 2250, 2257, 2263], [2208, 2215, 2216, 2248, 2255], [2206, 2217, 2233, 2265, 2273], [2167, 2234, 2243, 2270, 2276], [2228, 2252, 2280], [], [2294, 2297], [2167, 2217, 2239, 2265, 2270, 2307], [2177, 2189, 2192, 2251, 2253, 2274], [], [2195, 2208, 2233, 2256, 2268, 2269], [], [2215, 2229, 2237, 2255, 2266], [2259, 2272, 2296], [2226, 2236, 2263], [2189, 2222, 2244, 2258, 2274, 2285], [2199, 2228, 2240, 2271, 2280, 2289], [2177, 2231, 2244, 2274], [2220, 2235, 2257, 2278], [2208, 2237, 2248, 2256, 2262, 2266], [2208, 2246, 2255, 2262, 2268], [2220, 2236, 2254, 2263, 2278, 2284, 2291, 2292], [2209, 2222, 2223, 2251, 2282, 2285], [2249, 2294, 2296, 2324], [2302, 2314], [2221, 2230, 2235, 2267, 2278, 2290], [2255, 2256, 2266, 2268, 2281], [2236, 2250, 2257, 2291], [], [2217, 2238, 2243, 2273, 2287, 2306, 2307], [2248, 2255, 2262, 2281], [2230, 2234, 2261, 2276, 2290, 2295, 2304], [2246, 2256, 2262, 2269, 2281, 2286], [2233, 2246, 2268, 2275, 2286], [2239, 2243, 2276, 2307, 2310, 2327], [2227, 2252, 2279, 2289, 2309], [2249, 2296, 2298, 2323], [2233, 2238, 2265, 2275, 2287], [2231, 2244, 2251, 2253, 2285, 2312, 2313], [2233, 2269, 2273, 2287, 2300, 2303], [2234, 2239, 2267, 2270, 2295, 2310], [2209, 2227, 2279, 2282, 2293, 2301], [2235, 2254, 2257, 2261, 2284, 2290, 2318, 2328], [2227, 2271, 2277, 2301, 2309], [2240, 2252, 2289], [2262, 2266, 2268, 2286, 2299], [2209, 2258, 2277, 2285, 2293, 2308], [], [2257, 2278, 2292, 2318], [2251, 2258, 2274, 2282, 2308, 2313, 2319, 2320], [2268, 2269, 2281, 2299, 2300], [2265, 2273, 2275, 2303, 2306, 2325], [], [2252, 2271, 2280, 2309, 2322], [2261, 2267, 2278, 2304, 2328], [2257, 2263, 2292, 2326], [2257, 2284, 2291, 2318, 2326, 2331], [2277, 2282, 2301, 2308, 2321], [2242, 2259, 2297, 2324, 2338], [2267, 2276, 2304, 2310, 2329], [2249, 2259, 2272, 2323, 2324, 2355], [2242, 2294, 2330, 2338], [2272, 2323, 2341], [2281, 2286, 2300, 2317], [2275, 2286, 2299, 2303, 2316, 2317], [2277, 2279, 2293, 2309, 2321, 2334], [2260, 2314], [2275, 2287, 2300, 2316, 2325], [2267, 2290, 2295, 2328, 2329], [], [2265, 2287, 2307, 2325, 2332], [2243, 2265, 2270, 2306, 2327, 2332, 2340, 2345], [2282, 2285, 2293, 2320, 2321, 2333], [2271, 2279, 2289, 2301, 2322, 2334], [2270, 2276, 2295, 2327, 2329], [2231, 2312, 2352, 2382], [2231, 2274, 2311, 2313, 2352], [2274, 2285, 2312, 2319, 2351, 2352], [2260, 2302], [], [2300, 2303, 2317, 2335, 2336, 2339], [2299, 2300, 2316, 2335], [2278, 2284, 2292, 2328, 2331, 2347], [2285, 2313, 2320, 2337, 2351], [2285, 2308, 2319, 2333, 2334, 2337, 2360], [2293, 2301, 2308, 2333, 2334], [2289, 2309, 2334, 2350], [2272, 2296, 2298, 2341, 2355, 2369, 2374], [2259, 2294, 2296, 2338, 2355, 2363, 2369], [2287, 2303, 2306, 2332, 2336], [2291, 2292, 2331, 2353], [2270, 2307, 2310, 2329, 2340, 2361], [2278, 2290, 2304, 2318, 2329, 2342, 2346, 2347], [2295, 2304, 2310, 2327, 2328, 2342, 2361, 2368, 2375], [2297, 2338, 2364, 2371], [2292, 2318, 2326, 2347, 2353, 2356], [2306, 2307, 2325, 2336, 2345], [2308, 2320, 2321, 2334], [2301, 2309, 2320, 2321, 2322, 2333, 2350, 2360], [2316, 2317, 2339, 2348], [2316, 2325, 2332, 2339, 2344, 2345], [2319, 2320, 2351, 2360, 2365], [2294, 2297, 2324, 2330, 2363, 2371], [2316, 2335, 2336, 2344, 2348], [2307, 2327, 2345, 2354, 2361], [2298, 2323, 2358, 2374], [2328, 2329, 2346, 2368, 2370], [], [2336, 2339, 2345, 2348, 2357, 2367], [2307, 2332, 2336, 2340, 2344, 2354, 2357, 2359], [2328, 2342, 2347, 2366, 2370], [2318, 2328, 2331, 2346, 2356, 2362, 2366], [2335, 2339, 2344, 2367], [], [2322, 2334, 2360, 2373], [2313, 2319, 2337, 2352, 2365, 2384, 2387], [2311, 2312, 2313, 2351, 2382, 2384], [2326, 2331, 2356], [2340, 2345, 2359, 2361, 2372, 2375], [2296, 2323, 2324, 2369], [2331, 2347, 2353, 2362], [2344, 2345, 2359, 2367, 2378], [2341, 2374, 2408, 2412], [2345, 2354, 2357, 2372, 2378, 2379, 2385], [2320, 2334, 2337, 2350, 2365, 2373, 2376, 2380], [2327, 2329, 2340, 2354, 2375], [2347, 2356, 2366], [2324, 2338, 2369, 2371, 2390, 2395], [2330, 2371, 2394], [2337, 2351, 2360, 2376, 2387], [2346, 2347, 2362, 2370, 2381], [2344, 2348, 2357, 2377, 2378], [2329, 2342, 2370, 2375, 2383, 2389, 2392], [2323, 2324, 2355, 2363, 2374, 2390, 2405, 2419, 2423], [2342, 2346, 2366, 2368, 2381, 2392], [2330, 2338, 2363, 2364, 2394, 2395], [2354, 2359, 2375, 2379, 2386, 2388], [2350, 2360, 2380, 2393, 2396], [2323, 2341, 2358, 2369, 2408, 2419, 2422], [2329, 2354, 2361, 2368, 2372, 2383, 2388], [2360, 2365, 2380, 2387, 2397], [2367, 2378, 2391, 2400, 2403], [2357, 2359, 2367, 2377, 2385, 2391, 2413], [2359, 2372, 2385, 2386], [2360, 2373, 2376, 2393, 2396, 2397, 2402], [2366, 2370, 2392], [2311, 2352, 2384, 2404], [2368, 2375, 2388, 2389, 2399], [2351, 2352, 2382, 2387, 2404, 2411, 2414], [2359, 2378, 2379, 2386, 2413, 2416], [2372, 2379, 2385, 2388, 2399, 2409, 2416, 2418], [2351, 2365, 2376, 2384, 2397, 2411], [2372, 2375, 2383, 2386, 2399], [2368, 2383, 2392, 2398, 2399, 2401], [2363, 2369, 2395, 2405], [2377, 2378, 2403, 2413], [2368, 2370, 2381, 2389, 2398, 2406], [2373, 2380, 2396], [2364, 2371, 2395, 2417], [2363, 2371, 2390, 2394, 2405, 2417, 2421], [2373, 2380, 2393, 2402], [2376, 2380, 2387, 2402, 2407, 2411, 2415], [2389, 2392, 2401, 2406], [2383, 2386, 2388, 2389, 2401, 2409], [2377, 2403, 2410, 2426], [2389, 2398, 2399, 2406, 2409, 2420, 2427], [2380, 2396, 2397, 2407, 2415], [2377, 2391, 2400, 2410, 2413], [2382, 2384, 2414, 2434], [2369, 2390, 2395, 2421, 2423, 2430, 2433], [2392, 2398, 2401, 2427], [2397, 2402, 2415], [2358, 2374, 2412, 2422], [2386, 2399, 2401, 2418, 2420], [2400, 2403, 2413, 2426, 2428], [2384, 2387, 2397, 2414, 2415, 2424, 2432], [2358, 2408, 2422], [2378, 2385, 2391, 2403, 2410, 2416, 2428, 2429], [2384, 2404, 2411, 2432, 2434], [2397, 2402, 2407, 2411, 2424], [2385, 2386, 2413, 2418, 2429, 2431, 2435], [2394, 2395, 2421, 2441], [2386, 2409, 2416, 2420, 2425, 2431, 2438], [2369, 2374, 2422, 2423], [2401, 2409, 2418, 2425, 2427], [2395, 2405, 2417, 2430, 2441], [2374, 2408, 2412, 2419], [2369, 2405, 2419, 2433], [2411, 2415, 2432], [2418, 2420, 2427, 2436, 2437], [2400, 2410, 2428, 2442, 2446], [2401, 2406, 2420, 2425, 2437], [2410, 2413, 2426, 2429, 2442, 2444], [2413, 2416, 2428, 2435, 2444, 2445], [2405, 2421, 2433, 2441, 2443, 2448], [2416, 2418, 2435, 2438, 2440], [2411, 2414, 2424, 2434], [2405, 2423, 2430, 2443], [2404, 2414, 2432], [2416, 2429, 2431, 2440, 2445], [2425, 2437, 2438], [2425, 2427, 2436], [2418, 2431, 2436, 2440, 2450], [2451], [2431, 2435, 2438, 2445, 2449, 2450], [2417, 2421, 2430, 2448], [2426, 2428, 2444, 2446, 2452, 2453], [2430, 2433, 2448], [2428, 2429, 2442, 2445, 2452], [2429, 2435, 2440, 2444, 2449, 2452, 2456], [2426, 2442, 2453, 2454], [], [2430, 2441, 2443], [2440, 2445, 2450, 2456], [2438, 2440, 2449, 2456], [2439, 2455, 2458], [2442, 2444, 2445, 2453, 2456, 2457, 2461], [2442, 2446, 2452, 2454, 2457, 2460], [2446, 2453, 2460, 2466], [2451, 2458, 2459], [2445, 2449, 2450, 2452, 2461], [2452, 2453, 2460, 2461, 2464, 2465], [2451, 2455, 2459], [2455, 2458], [2453, 2454, 2457, 2464, 2466], [2452, 2456, 2457, 2465], [2467], [], [2457, 2460, 2465, 2466, 2468], [2457, 2461, 2464, 2468, 2470], [2454, 2460, 2464, 2468, 2471], [2462, 2469], [2464, 2465, 2466, 2470, 2471, 2472], [2467], [2465, 2468, 2472], [2466, 2468, 2472, 2476], [2468, 2470, 2471], [], [2475], [2474], [2471], [2478], [2477]]
